import { useCallback, useEffect, useMemo, useState } from "react";
//old import { Link } from "react-router-dom";
import { Link, useSearchParams } from "react-router-dom";
import {
    Building2, ClipboardList, SlidersHorizontal, Plus, Search, Loader2, Trash2, ExternalLink, CheckCircle2, Pencil, KeyRound,
    MessageSquare,
    XCircle,
    Paperclip,
} from "lucide-react";
import api from "../../api/api";
import InlineTableSkeleton from "../../components/layout/InlineTableSkeleton";
import { seatPrice, seatTotal } from "../../utils/orgPricing";
//old import { monthEnd, quote } from "../org/OrgLicenses";
//old import { quote } from "../org/OrgLicenses";
import { quote, monthEnd } from "../org/OrgLicenses";
import { FEATURE_LABEL, CHANGE_STATUS } from "../org/OrgScoring";
import {
    Alert, EmptyState, Field, OrgModal, PageHeader, Panel, Pill, TabBar, apiError, formatDate, useOrgStyles, ORG_TYPE_LABEL,
    //old PARTNER_TYPE_LABEL,
    //old PARTNER_TYPE_LABEL, downloadNonprofitProof,
    PARTNER_TYPE_LABEL, downloadNonprofitProof, downloadChangeRequestAttachment,
    LICENSE_TYPE_LABEL,
} from "../../components/org/orgUi";
import LicensesModal from "../../components/org/LicensesModal";

const TABS = [
    { key: "orgs", label: "Organizations", icon: Building2 },
    { key: "requests", label: "License requests", icon: KeyRound },
    { key: "changes", label: "Change requests", icon: MessageSquare },
    { key: "assessments", label: "Assessments", icon: ClipboardList },
    { key: "evaluations", label: "Custom evaluations", icon: SlidersHorizontal },
];

const DEFAULTS = {
    education: { coachLicenseLimit: 25, programLimit: 25, studentLicenseLimit: 0 },
    enterprise: { coachLicenseLimit: 1, programLimit: 1, studentLicenseLimit: 0 },
    // Community Partner (Oct 16): 25 free student licenses and up to 3 admins
    //old nonprofit: { coachLicenseLimit: 1, programLimit: 1, studentLicenseLimit: 25, adminLimit: 3 },
    // and 2 coach licenses (Alicia, Oct 30), as the backend's ORG_DEFAULTS
    nonprofit: { coachLicenseLimit: 2, programLimit: 1, studentLicenseLimit: 25, adminLimit: 3 },
};

/** What approving did with a Community Partner's paid package (PUT /org/<id> -> approval).
 *  money and perPeriod are the license request helpers further down. */
function approvalNotice(org, approval) {
    if (!approval || !approval.licenses) return `${org.OrgName} is approved. Its admins were emailed.`;
    const what = `${approval.licenses} more licenses (${approval.package} in all)`;
    if (approval.charged) return `${org.OrgName} is approved. Its card was charged ${money(approval.total)} ${perPeriod(approval.billingMode)} for ${what}`
        + `${approval.renewsOn ? `; it renews on ${formatDate(approval.renewsOn)}` : ""}.`;
    if (approval.reason === "card_failed") return `${org.OrgName} is approved, but its card was declined${approval.message ? ` (${approval.message.replace(/\.$/, "")})` : ""}. It can pay for ${what} on its Licenses page.`;
    if (approval.reason === "no_card") return `${org.OrgName} is approved. It didn't save a card, so it pays for ${what} on its Licenses page.`;
    // the card is charged only with the price the org agreed to when it saved it
    if (approval.reason === "price_changed") return `${org.OrgName} is approved. Its package now costs ${money(approval.total)} ${perPeriod(approval.billingMode)}`
        + (approval.agreedTotal != null ? `, not the ${money(approval.agreedTotal)} ${perPeriod(approval.agreedBillingMode)} it agreed to,` : `, and no agreed price was kept with its card,`)
        + ` so its card wasn't charged. It pays for ${what} on its Licenses page.`;
    if (approval.reason === "error") return `${org.OrgName} is approved, but charging its card didn't finish${approval.message ? ` (${approval.message.replace(/\.$/, "")})` : ""}. `
        + (approval.requestId
            ? `Check its payment in Stripe: if there's none, ask it to pay for ${what} on its Licenses page (its email says Pono Pilot will set up the rest with it).`
            //old : `Its email says Pono Pilot will set up the rest: set up its ${what} with Set up licenses on the License requests tab.`);
            : `Its email says Pono Pilot will set up the rest: add its ${what} with Licenses on its row.`);
    //old return `${org.OrgName} is approved. Set up its ${what} with Set up licenses on the License requests tab.`;
    return `${org.OrgName} is approved. Add its ${what} with Licenses on its row.`;
}

//old /** Approving a Community Partner charges the card it saved at sign-up: ask first, with the amount. */
//old function confirmCharge(org) {
//old     // (a card saved without an agreed price is never charged: nothing to confirm)
//old     if (org.OrgType !== "nonprofit" || !(org.SignupPackage > 25) || !org.CardSaved || org.SignupQuotedTotal == null) return true;
//old     const paid = org.SignupPackage - 25;
//old     return window.confirm(`Approve ${org.OrgName}?\n\nThis charges the card it saved at sign-up ${money(org.SignupQuotedTotal)} ${perPeriod(org.SignupQuotedBillingMode)} `
//old         + `for ${paid} licenses (${org.SignupPackage} in all), renewing automatically. If its package costs something else now, `
//old         + "nothing is charged and it pays the new price on its Licenses page.");
//old }
// Approving a Community Partner charges the card it saved at sign-up (a card saved without an agreed price never is)
const chargesCard = (org) => org.OrgType === "nonprofit" && org.SignupPackage > 25 && org.CardSaved && org.SignupQuotedTotal != null;
// A Community Partner's 501(c)(3) proof isn't uploaded yet (the box said it comes later, in Settings)
//old const proofOwed = (org) => org.OrgType === "nonprofit" && !org.Nonprofit501c3ProofFileName;
// (only one that ticked it: saying it's a 501(c)(3) is optional since Alicia, Oct 30)
const proofOwed = (org) => org.OrgType === "nonprofit" && !org.Nonprofit501c3ProofFileName && !!org.Nonprofit501c3AttestedOn;
// Approving is asked first (ApproveConfirm) when it charges a card, the sign-up's email was never verified, or its proof isn't in
const needsApproveConfirm = (org) => chargesCard(org) || !org.ContactEmailVerified || proofOwed(org);

/** Approve, asked first: the amount a saved card is charged, a 501(c)(3) proof that isn't in yet, and for an
 *  email that was never verified a tick box that it was checked another way, as when approving a coach
 *  (Employee Management). onApprove gets what the approval sends along ({ approveUnverified: true } after the tick box). */
function ApproveConfirm({ org, onCancel, onApprove }) {
    const s = useOrgStyles();
    const [checked, setChecked] = useState(false);
    const unverified = !org.ContactEmailVerified;
    return (
        <OrgModal
            isOpen
            onClose={onCancel}
            title={`Approve ${org.OrgName}?`}
            footer={<>
                <button type="button" className={s.btnSecondary} onClick={onCancel}>Cancel</button>
                <button type="button" className={s.btnPrimary} disabled={unverified && !checked}
                        onClick={() => onApprove(unverified ? { approveUnverified: true } : {})}>
                    <CheckCircle2 size={14} /> Approve
                </button>
            </>}
        >
            <div className={`space-y-3 text-sm [overflow-wrap:anywhere] ${s.body}`}>
                <p>Its admins will be able to sign in, and they get an email saying it's approved.</p>
                {chargesCard(org) && (
                    <p>
                        This charges the card it saved at sign-up {money(org.SignupQuotedTotal)} {perPeriod(org.SignupQuotedBillingMode)} for{" "}
                        {org.SignupPackage - 25} licenses ({org.SignupPackage} in all), renewing automatically. If its package costs something
                        else now, nothing is charged and it pays the new price on its Licenses page.
                    </p>
                )}
                {proofOwed(org) && <p>Its 501(c)(3) proof isn't uploaded yet: it uploads it in Settings once it's approved.</p>}
                {unverified && (
                    <div className={`rounded-xl border p-3 ${s.dark ? "border-amber-800 bg-amber-900/20 text-amber-200" : "border-amber-200 bg-amber-50 text-amber-800"}`}>
                        {org.OrgName} never verified its email{org.PrimaryContactEmail ? ` (${org.PrimaryContactEmail})` : ""}, so we can't
                        be sure the email belongs to them.
                        <label className="mt-2 flex items-start gap-2">
                            <input type="checkbox" className="mt-0.5" checked={checked} onChange={(e) => setChecked(e.target.checked)} />
                            <span>I checked this email another way. Approve anyway.</span>
                        </label>
                    </div>
                )}
            </div>
        </OrgModal>
    );
}

/** A plan Stripe couldn't stop when the org was archived or declined: it's still billed. */
const billingNotStoppedText = (org, ids) =>
    `${org.OrgName}: billing for license request ${ids.map((id) => `#${id}`).join(", ")} wasn't stopped. End it on the License requests tab.`;
/** Suspending pauses renewal and reactivating resumes it: a plan Stripe couldn't change. */
const renewalNotChangedText = (org, ids, on) =>
    `${org.OrgName}: renewal of license request ${ids.map((id) => `#${id}`).join(", ")} wasn't turned ${on ? "back on" : "off"}. `
    //old + `Turn it ${on ? "on" : "off"} on the License requests tab.`;
    // (the Licenses window turns it back on, or pauses it again the way suspending does)
    + (on ? "Turn it on with Licenses on its row." : "Pause it with Licenses on its row.");

/** Admin → Organizations: orgs (approve, limits, sponsored plans), scoped assessments, custom evaluations. */
export default function OrganizationManagement() {
    //old const [tab, setTab] = useState("orgs");
    // The tab is in the address (?tab=changes), like the coaching tabs, so a link can open it: an org's
    // Requests page sends a Pono Pilot admin straight to Change requests
    const [searchParams, setSearchParams] = useSearchParams();
    const tab = TABS.some((t) => t.key === searchParams.get("tab")) ? searchParams.get("tab") : "orgs";
    const setTab = (key) => {
        const next = new URLSearchParams(searchParams);
        if (key === "orgs") next.delete("tab");
        else next.set("tab", key);
        setSearchParams(next, { replace: true });
    };
    //old const [options, setOptions] = useState({ tiers: [], surveys: [], programs: [] });
    const [options, setOptions] = useState({ tiers: [], surveys: [], programs: [], cohorts: [] });
    const [orgs, setOrgs] = useState([]);

    const loadOptions = useCallback(async () => {
        try {
            const [opt, list] = await Promise.all([api.get("/org/admin/options"), api.get("/org/admin/orgs")]);
            setOptions(opt.data);
            setOrgs(list.data.organizations || []);
        } catch { /* each tab shows its own load error */ }
    }, []);

    useEffect(() => { loadOptions(); }, [loadOptions]);

    //old // Pending license requests show as a count on the tab, so they get noticed.
    // License requests waiting for payment show as a count on the tab, so they get followed up (organizations
    // can't ask for licenses themselves any more, so none wait for approval)
    const [pendingRequests, setPendingRequests] = useState(0);
    const loadPendingCount = useCallback(() => {
        //old api.get("/org/admin/license-requests", { params: { status: "pending" } })
        api.get("/org/admin/license-requests", { params: { status: "approved" } })
            //old .then((res) => setPendingRequests((res.data.requests || []).length))
            // (not ones whose Pay by day is over or whose price changed since they were set up: they can't be paid anymore)
            .then((res) => setPendingRequests((res.data.requests || []).filter((r) => !r.PayByPassed && !r.QuoteChanged).length))
            .catch(() => setPendingRequests(0));
    }, []);
    useEffect(() => { loadPendingCount(); }, [loadPendingCount]);
    // New change requests (Checklists & Scoring page) get a count on their tab too.
    const [pendingChanges, setPendingChanges] = useState(0);
    const loadPendingChanges = useCallback(() => {
        api.get("/org/admin/change-requests", { params: { status: "pending" } })
            .then((res) => setPendingChanges((res.data.requests || []).length))
            .catch(() => setPendingChanges(0));
    }, []);
    useEffect(() => { loadPendingChanges(); }, [loadPendingChanges]);
    //old const tabs = TABS.map((t) => (t.key === "requests" && pendingRequests > 0 ? { ...t, label: `${t.label} (${pendingRequests})` } : t));
    const pendingCounts = { requests: pendingRequests, changes: pendingChanges };
    const tabs = TABS.map((t) => (pendingCounts[t.key] > 0 ? { ...t, label: `${t.label} (${pendingCounts[t.key]})` } : t));

    return (
        <div className="mx-auto max-w-7xl px-0 md:px-4 py-2 md:py-6">
            {/* old <PageHeader title="Organizations" subtitle="Education and Enterprise accounts, their licenses, and the custom assessments and evaluations assigned to them." /> */}
            <PageHeader title="Organizations" subtitle="Education, Enterprise and Community Partner accounts, their licenses, and the custom assessments and evaluations assigned to them." />
            <TabBar tabs={tabs} active={tab} onChange={setTab} label="Organization admin sections" />
            {/* old {tab === "orgs" && <OrgsTab tiers={options.tiers} onChanged={loadOptions} />} */}
            {/* (and the codes that have their own Resume Checklist, for Edit) */}
            {/* (licenses set up in a row's Licenses window, or on approval, wait for payment: the License requests count follows) */}
            {tab === "orgs" && <OrgsTab tiers={options.tiers} checklists={options.checklists} onChanged={() => { loadOptions(); loadPendingCount(); }} />}
            {tab === "requests" && <LicenseRequestsTab orgs={orgs} onChanged={() => { loadPendingCount(); loadOptions(); }} />}
            {tab === "changes" && <ChangeRequestsTab onChanged={loadPendingChanges} />}
            {tab === "assessments" && <AssessmentsTab options={options} orgs={orgs} />}
            {tab === "evaluations" && <EvaluationsTab options={options} orgs={orgs} />}
        </div>
    );
}

// ── Organizations ────────────────────────────────────────────────────────────

/** "used / seats" where seats = the limit set here + seats added through license requests (paid or free). */
//old function SeatCount({ used, base, purchased }) {
// paid: the ones on a paid plan, which say "paid" like the Licenses window; "added" is for the rest (given, or bought without renewal)
function SeatCount({ used, base, purchased, paid = 0 }) {
    const s = useOrgStyles();
    const total = base + (purchased || 0);
    return (
        <span className="inline-flex flex-wrap items-center gap-1.5">
            {used} / {total}
            {total > 0 && used >= total && <Pill tone="danger">Full</Pill>}
            {/* old {purchased > 0 && <span className={`text-xs ${s.muted}`}>({purchased} added)</span>} */}
            {purchased > 0 && (
                <span className={`text-xs ${s.muted}`}>
                    ({[paid > 0 ? `${paid} paid` : null, purchased - paid > 0 ? `${purchased - paid} added` : null].filter(Boolean).join(" + ")})
                </span>
            )}
        </span>
    );
}

//old function OrgsTab({ tiers, onChanged }) {
function OrgsTab({ tiers, checklists, onChanged }) {
    const s = useOrgStyles();
    const [orgs, setOrgs] = useState(null);
    const [search, setSearch] = useState("");
    const [status, setStatus] = useState("");
    const [error, setError] = useState("");
    const [notice, setNotice] = useState("");
    const [editing, setEditing] = useState(null); // null | {} | org
    const [busyId, setBusyId] = useState(null); // an org being approved or declined
    const [confirming, setConfirming] = useState(null); // the org whose Approve is asked first (ApproveConfirm)
    const [licensesFor, setLicensesFor] = useState(null); // the org whose Licenses window is open

    const load = useCallback(async () => {
        try {
            const params = new URLSearchParams();
            if (search.trim()) params.set("search", search.trim());
            if (status) params.set("status", status);
            const res = await api.get(`/org/admin/orgs?${params}`);
            setOrgs(res.data.organizations || []);
        } catch (err) {
            setError(apiError(err, "Couldn't load organizations."));
            setOrgs([]);
        }
    }, [search, status]);

    useEffect(() => {
        const t = setTimeout(load, 250);
        return () => clearTimeout(t);
    }, [load]);

    //old const approve = async (org) => {
    // extra: what ApproveConfirm sends along, once it was asked
    const approve = async (org, extra = null) => {
        // it may charge a saved card: say how much first, and one click at a time
        //old if (busyId || !confirmCharge(org)) return;
        if (busyId) return;
        if (!extra && needsApproveConfirm(org)) {
            setConfirming(org);
            return;
        }
        setConfirming(null);
        setBusyId(org.OrgID);
        setNotice("");
        try {
            //old await api.put(`/org/${org.OrgID}`, { status: "active" });
            //old const res = await api.put(`/org/${org.OrgID}`, { status: "active" });
            const res = await api.put(`/org/${org.OrgID}`, { status: "active", ...extra });
            // a Community Partner's paid package is charged when it's approved
            setNotice(approvalNotice(org, res.data.approval));
            await Promise.all([load(), onChanged()]);
        } catch (err) { setError(apiError(err)); }
        setBusyId(null);
    };

    // Not approving a pending organization: it's archived and its contact is emailed
    const decline = async (org) => {
        if (busyId) return; // another approval or decline is still running
        //old const note = window.prompt(`Decline ${org.OrgName}? It's archived and ${org.PrimaryContactEmail || "its contact"} gets an email. `
        //old     + "Add a note for them (optional):", "");
        // (the email says they can apply again with the same email)
        const note = window.prompt(`Decline ${org.OrgName}? It's archived and ${org.PrimaryContactEmail || "its contact"} gets an email `
            + "saying they can apply again with the same email. Add a note for them (optional):", "");
        if (note === null) return;
        setBusyId(org.OrgID);
        setNotice("");
        try {
            const res = await api.post(`/org/admin/orgs/${org.OrgID}/decline`, { note });
            setNotice(`${org.OrgName} was declined and its contact was emailed.`);
            if (res.data.billingNotStopped?.length) setError(billingNotStoppedText(org, res.data.billingNotStopped));
            await Promise.all([load(), onChanged()]);
        } catch (err) { setError(apiError(err)); }
        setBusyId(null);
    };

    const archive = async (org) => {
        if (busyId === org.OrgID) return; // still being approved: its card may be charging
        if (!window.confirm(`Archive ${org.OrgName}? Its licenses end and it disappears from lists. This can't be undone from the UI.`)) return;
        try {
            //old await api.delete(`/org/admin/orgs/${org.OrgID}`);
            const res = await api.delete(`/org/admin/orgs/${org.OrgID}`);
            // a plan Stripe couldn't stop is still billed: say so, to end it by hand
            if (res.data.billingNotStopped?.length) setError(billingNotStoppedText(org, res.data.billingNotStopped));
            await Promise.all([load(), onChanged()]);
        } catch (err) { setError(apiError(err)); }
    };

    const pendingCount = (orgs || []).filter((o) => o.Status === "pending").length;

    return (
        <>
            <Alert onClose={() => setError("")}>{error}</Alert>
            <Alert kind="success" onClose={() => setNotice("")}>{notice}</Alert>
            <Panel
                padded={false}
                title={pendingCount ? <span className="inline-flex items-center gap-2">Organizations <Pill tone="warning">{pendingCount} awaiting approval</Pill></span> : "Organizations"}
                actions={<button type="button" className={s.btnPrimary} onClick={() => setEditing({})}><Plus size={16} /> New organization</button>}
            >
                <div className={`flex flex-col gap-3 border-b px-5 py-4 md:flex-row ${s.dark ? "border-slate-700" : "border-slate-100"}`}>
                    <div className="relative flex-1">
                        <Search size={16} className={`pointer-events-none absolute left-3 top-1/2 -translate-y-1/2 ${s.muted}`} />
                        <input aria-label="Search organizations" placeholder="Search by name or contact email" className={`${s.input} pl-9`}
                               value={search} onChange={(e) => setSearch(e.target.value)} />
                    </div>
                    <select aria-label="Filter by status" className={`${s.input} md:w-48`} value={status} onChange={(e) => setStatus(e.target.value)}>
                        <option value="">All statuses</option>
                        <option value="pending">Pending approval</option>
                        <option value="active">Active</option>
                        <option value="suspended">Suspended</option>
                    </select>
                </div>
                {!orgs ? (
                    <div className="flex justify-center py-10"><Loader2 className={`animate-spin ${s.muted}`} /></div>
                ) : orgs.length === 0 ? (
                    <EmptyState icon={Building2} title="No organizations found" />
                ) : (
                    <div className="relative overflow-x-auto">
                        <table className="w-full">
                            <thead>
                                <tr className={`border-b ${s.dark ? "border-slate-700" : "border-slate-100"}`}>
                                    <th className={s.th}>Organization</th>
                                    <th className={s.th}>Status</th>
                                    {/* old <th className={s.th}>Students</th> */}
                                    <th className={s.th}>Clients</th>
                                    <th className={s.th}>Programs</th>
                                    {/* old <th className={s.th}>Coach seats</th> */}
                                    {/* old <th className={s.th}>Student seats</th> */}
                                    <th className={s.th}>Coach licenses</th>
                                    {/* old <th className={s.th}>Student licenses</th> */}
                                    <th className={s.th}>Client licenses</th>
                                    <th className={s.th}><span className="sr-only">Actions</span></th>
                                </tr>
                            </thead>
                            <tbody>
                                {orgs.map((o) => (
                                    <tr key={o.OrgID} className={`border-b last:border-0 ${s.row}`}>
                                        <td className={s.td}>
                                            <div className={`font-semibold ${s.text}`}>{o.OrgName}</div>
                                            <div className="mt-1 flex flex-wrap gap-1">
                                                <Pill tone="primary">{ORG_TYPE_LABEL[o.OrgType]}</Pill>
                                                {o.IsSystem ? <Pill>System</Pill> : null}
                                            </div>
                                            {/* old {o.PrimaryContactEmail && <div className={`mt-1 text-xs ${s.muted}`}>{o.PrimaryContactName} · {o.PrimaryContactEmail}</div>} */}
                                            {/* (a long email breaks, so the column narrows and the row's buttons stay on a laptop's screen) */}
                                            {o.PrimaryContactEmail && <div className={`mt-1 text-xs ${s.muted} [overflow-wrap:anywhere]`}>{o.PrimaryContactName} · {o.PrimaryContactEmail}</div>}
                                            {o.Status === "pending" && o.SignupRequest && <div className={`mt-1 max-w-md line-clamp-2 break-words text-xs ${s.body}`} title={o.SignupRequest}>“{o.SignupRequest}”</div>}
                                            {/* A Community Partner waiting for approval: what it is, its 501(c)(3) box, its package and card */}
                                            {o.OrgType === "nonprofit" && o.Status === "pending" && (
                                                <div className={`mt-1 text-xs ${s.body}`}>
                                                    {PARTNER_TYPE_LABEL[o.PartnerType] || "Community Partner"}
                                                    {/* old {o.Nonprofit501c3AttestedOn && ` · 501(c)(3) ticked ${formatDate(o.Nonprofit501c3AttestedOn)}`} */}
                                                    {/* the box now means its proof comes later (JJ, Oct 23); an uploaded proof shows on the line below */}
                                                    {o.Nonprofit501c3AttestedOn && !o.Nonprofit501c3ProofFileName && ` · 501(c)(3) proof to come later (ticked ${formatDate(o.Nonprofit501c3AttestedOn)})`}
                                                    {o.SignupPackage && ` · ${o.SignupPackage} licenses`}
                                                    {/* no plan for its licensed students: approving gives it the Community Partner plan (or says to set one first) */}
                                                    {!o.SponsoredStudentTierID && " · No plan"}
                                                    {o.SignupPackage > 25 && (!o.CardSaved ? " · no card saved"
                                                        : o.SignupQuotedTotal != null ? ` · card saved: ${money(o.SignupQuotedTotal)} ${perPeriod(o.SignupQuotedBillingMode)} on approval`
                                                            : " · card saved (no agreed price: it pays after approval)")}
                                                </div>
                                            )}
                                            {/* its 501(c)(3) proof, which it can upload later in Settings (Alicia, Oct 22) */}
                                            {/* old {o.OrgType === "nonprofit" && ( */}
                                            {/* (only the Community Partner sign-up, which picks a package, asks whether it's a 501(c)(3): one Build My Biz Brand made shows nothing here) */}
                                            {o.OrgType === "nonprofit" && !!(o.SignupPackage || o.Nonprofit501c3AttestedOn || o.Nonprofit501c3ProofFileName) && (
                                                <div className={`mt-1 text-xs ${s.muted}`}>
                                                    {o.Nonprofit501c3ProofFileName ? (
                                                        <>501(c)(3) proof uploaded {formatDate(o.Nonprofit501c3ProofUploadedOn)} ·{" "}
                                                            <button type="button" className={`${s.btnLink} !text-xs`}
                                                                    onClick={() => downloadNonprofitProof(o.OrgID, o.Nonprofit501c3ProofFileName).catch((err) => setError(apiError(err)))}>
                                                                Download
                                                            </button>
                                                        </>
                                                    //old ) : "No 501(c)(3) proof uploaded yet"}
                                                    // (a pending one can't sign in to upload it yet; an approved one owes it until it does)
                                                    //old ) : o.Status === "pending" ? "501(c)(3) proof comes after approval, in its Settings" : "501(c)(3) proof owed: not uploaded yet"}
                                                    // (one that neither ticked the box nor sent a file didn't say it's one, which is optional since Alicia, Oct 30)
                                                    ) : !o.Nonprofit501c3AttestedOn ? "Not a 501(c)(3)"
                                                        : o.Status === "pending" ? "501(c)(3) proof comes after approval, in its Settings" : "501(c)(3) proof owed: not uploaded yet"}
                                                </div>
                                            )}
                                        </td>
                                        <td className={s.td}>
                                            <Pill tone={o.Status === "active" ? "success" : o.Status === "pending" ? "warning" : "danger"}>{o.Status}</Pill>
                                            {o.Status === "pending" && (
                                                <div className={`mt-1 text-xs ${s.muted}`}>{o.ContactEmailVerified ? "Email verified" : "Email not verified"} · {formatDate(o.CreatedOn)}</div>
                                            )}
                                        </td>
                                        <td className={`${s.td} tabular-nums`}>{o.StudentCount}</td>
                                        <td className={`${s.td} tabular-nums`}>{o.ProgramCount} / {o.ProgramLimit}</td>
                                        {/* old <td className={`${s.td} tabular-nums`}><SeatCount used={o.CoachLicensesUsed} base={o.CoachLicenseLimit} purchased={o.CoachLicensesPurchased} /></td> */}
                                        {/* old <td className={`${s.td} tabular-nums`}><SeatCount used={o.StudentLicensesUsed} base={o.StudentLicenseLimit} purchased={o.StudentLicensesPurchased} /></td> */}
                                        <td className={`${s.td} tabular-nums`}><SeatCount used={o.CoachLicensesUsed} base={o.CoachLicenseLimit} purchased={o.CoachLicensesPurchased} paid={o.CoachLicensesPaid} /></td>
                                        <td className={`${s.td} tabular-nums`}><SeatCount used={o.StudentLicensesUsed} base={o.StudentLicenseLimit} purchased={o.StudentLicensesPurchased} paid={o.StudentLicensesPaid} /></td>
                                        <td className={`${s.td} text-right`}>
                                            {/* old <div className="flex justify-end gap-1"> */}
                                            {/* The actions wrap (like the cohort list) instead of pushing the table past a laptop's screen, Approve and
                                                Decline on a line of their own: two buttons a line on a 1280 screen, the other four in one line from
                                                1366; every button keeps its words (Alicia, Sep 4: kept in sight, not hidden) */}
                                            <div className="flex min-w-[12.5rem] flex-wrap justify-end gap-1 min-[1366px]:min-w-[17rem]">
                                                {o.Status === "pending" && (
                                                    <>
                                                        {/* old <button type="button" className={s.btnSm} onClick={() => approve(o)}><CheckCircle2 size={14} /> Approve</button> */}
                                                        <button type="button" className={s.btnSm} disabled={busyId != null} onClick={() => approve(o)}><CheckCircle2 size={14} /> Approve</button>
                                                    </>
                                                )}
                                                {o.Status === "pending" && (
                                                    <button type="button" className={s.btnSm} disabled={busyId != null} onClick={() => decline(o)}><XCircle size={14} /> Decline</button>
                                                )}
                                                {o.Status === "pending" && <span className="basis-full" aria-hidden="true" />}
                                                {/* one place for its licenses: how many, what they cost and when a change starts (JJ, Oct 23) */}
                                                <button type="button" className={s.btnSm} onClick={() => setLicensesFor(o.OrgID)} aria-label={`Licenses of ${o.OrgName}`}>
                                                    {/* old <KeyRound size={14} /><span className="hidden xl:inline">Licenses</span> */}
                                                    <KeyRound size={14} /> Licenses
                                                </button>
                                                <Link to={`/org?orgId=${o.OrgID}`} className={s.btnSm} title="Open the organization portal" aria-label={`Manage ${o.OrgName}`}>
                                                    {/* old <ExternalLink size={14} /><span className="hidden xl:inline">Manage</span> */}
                                                    <ExternalLink size={14} /> Manage
                                                </Link>
                                                {/* old <button type="button" className={s.btnSm} onClick={() => setEditing(o)} aria-label={`Edit ${o.OrgName}`}><Pencil size={14} /></button> */}
                                                {/* Edit and Archive wait while this org is being approved (its card may be charging) */}
                                                {/* old <button type="button" className={s.btnSm} disabled={busyId === o.OrgID} onClick={() => setEditing(o)} aria-label={`Edit ${o.OrgName}`}><Pencil size={14} /></button> */}
                                                {/* (only icons: what they do shows on hover) */}
                                                <button type="button" className={s.btnSm} disabled={busyId === o.OrgID} onClick={() => setEditing(o)} aria-label={`Edit ${o.OrgName}`} title="Edit"><Pencil size={14} /></button>
                                                {!o.IsSystem && (
                                                    <>
                                                        {/* old <button type="button" className={s.btnDanger} onClick={() => archive(o)} aria-label={`Archive ${o.OrgName}`}><Trash2 size={14} /></button> */}
                                                        {/* old <button type="button" className={s.btnDanger} disabled={busyId === o.OrgID} onClick={() => archive(o)} aria-label={`Archive ${o.OrgName}`}><Trash2 size={14} /></button> */}
                                                        <button type="button" className={s.btnDanger} disabled={busyId === o.OrgID} onClick={() => archive(o)} aria-label={`Archive ${o.OrgName}`} title="Archive"><Trash2 size={14} /></button>
                                                    </>
                                                )}
                                            </div>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                )}
            </Panel>
            {editing && (
                <OrgEditor org={editing} tiers={tiers} onClose={() => setEditing(null)}
                           onResult={(r) => { if (r.notice) setNotice(r.notice); if (r.error) setError(r.error); }}
                           onLicenses={(id) => setLicensesFor(id)}
                           checklists={checklists}
                           current={(orgs || []).find((o) => o.OrgID === editing.OrgID) || editing}
                           onSaved={async () => { setEditing(null); await Promise.all([load(), onChanged()]); }} />
            )}
            {licensesFor && (
                <LicensesModal orgId={licensesFor} onClose={() => setLicensesFor(null)} onChanged={() => Promise.all([load(), onChanged()])} />
            )}
            {confirming && <ApproveConfirm org={confirming} onCancel={() => setConfirming(null)} onApprove={(extra) => approve(confirming, extra)} />}
        </>
    );
}

//old function OrgEditor({ org, tiers, onClose, onSaved }) {
// onResult: how an approval (a charged card) or a suspension (billing that didn't stop) went
//old function OrgEditor({ org, tiers, onClose, onSaved, onResult }) {
// onLicenses: opens the org's Licenses window (an existing org's licenses change there); current: the org as
// the list has it now, so the license summary follows changes made in that window (the form keeps what's typed)
//old function OrgEditor({ org, tiers, onClose, onSaved, onResult, onLicenses, current }) {
// checklists: the codes that have their own Resume Checklist (Admin options), for the org's own one
function OrgEditor({ org, tiers, onClose, onSaved, onResult, onLicenses, current, checklists }) {
    const s = useOrgStyles();
    const isNew = !org.OrgID;
    const [form, setForm] = useState({
        orgName: org.OrgName || "",
        orgType: org.OrgType || "education",
        status: org.Status || "active",
        primaryContactName: org.PrimaryContactName || "",
        primaryContactEmail: org.PrimaryContactEmail || "",
        primaryContactPhone: org.PrimaryContactPhone || "",
        // the billing contact (the Secondary* columns, Alicia Oct 2): it gets the emails about money too
        secondaryContactName: org.SecondaryContactName || "",
        secondaryContactEmail: org.SecondaryContactEmail || "",
        secondaryContactPhone: org.SecondaryContactPhone || "",
        coachLicenseLimit: org.CoachLicenseLimit ?? DEFAULTS.education.coachLicenseLimit,
        studentLicenseLimit: org.StudentLicenseLimit ?? DEFAULTS.education.studentLicenseLimit,
        programLimit: org.ProgramLimit ?? DEFAULTS.education.programLimit,
        sponsoredStudentTierId: org.SponsoredStudentTierID || "",
        sponsoredCoachTierId: org.SponsoredCoachTierID || "",
        // most org admins (blank = no limit) and, for a Community Partner, what kind it is
        adminLimit: org.AdminLimit ?? "",
        partnerType: org.PartnerType || "",
        // the code its students enter for its own Resume Checklist ("" = the standard one)
        checklistCode: org.ChecklistCode || "",
    });
    const [admin, setAdmin] = useState({ firstName: "", lastName: "", email: "" });
    const [saving, setSaving] = useState(false);
    const [confirming, setConfirming] = useState(false); // approving here is asked first too (ApproveConfirm)
    const [error, setError] = useState("");
    const [notice, setNotice] = useState("");
    const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

    const onType = (e) => {
        const orgType = e.target.value;
        // New orgs follow the type defaults (Education 25/25, Enterprise 1/1).
        //old setForm((f) => (isNew ? { ...f, orgType, ...DEFAULTS[orgType] } : { ...f, orgType }));
        // (a Community Partner also gets 25 student licenses and up to 3 admins)
        setForm((f) => (isNew ? { ...f, orgType, adminLimit: "", ...DEFAULTS[orgType] } : { ...f, orgType }));
    };

    const studentTiers = tiers.filter((t) => !t.Audiences?.length || t.Audiences.includes("Student") || t.Audiences.includes("Enterprise"));
    const coachTiers = tiers.filter((t) => !t.Audiences?.length || t.Audiences.includes("Coach") || t.Audiences.includes("Enterprise"));

    //old const submit = async (e) => {
    //old     e.preventDefault();
    // extra: what ApproveConfirm sends along, once it was asked
    const submit = async (e, extra = null) => {
        e?.preventDefault();
        // approving here may charge a Community Partner's saved card too: ask first, like Approve
        const approving = !isNew && org.Status === "pending" && form.status === "active";
        //old if (approving && !confirmCharge(org)) return;
        if (approving && !extra && needsApproveConfirm(org)) {
            setConfirming(true);
            return;
        }
        setConfirming(false);
        setSaving(true);
        setError("");
        const payload = {
            ...form,
            sponsoredStudentTierId: form.sponsoredStudentTierId || null,
            sponsoredCoachTierId: form.sponsoredCoachTierId || null,
            ...extra,
        };
        // An existing org's licenses change in its Licenses window, so saving here can't put back an older number
        if (!isNew) {
            delete payload.coachLicenseLimit;
            delete payload.studentLicenseLimit;
        }
        // The checklist code goes only when it's changed, so saving anything else never needs it checked again
        if (payload.checklistCode === (org.ChecklistCode || "")) delete payload.checklistCode;
        try {
            if (isNew) {
                const res = await api.post("/org/admin/orgs", { ...payload, orgAdmin: admin.email ? admin : undefined });
                if (res.data.orgAdminError) {
                    setError(`Organization created, but the org admin login wasn't: ${res.data.orgAdminError}`);
                    setSaving(false);
                    return;
                }
            } else {
                //old await api.put(`/org/${org.OrgID}`, payload);
                const res = await api.put(`/org/${org.OrgID}`, payload);
                onResult?.({
                    notice: approving ? approvalNotice(org, res.data.approval) : "",
                    error: res.data.billingNotStopped?.length ? renewalNotChangedText(org, res.data.billingNotStopped, false)
                        : res.data.renewalNotResumed?.length ? renewalNotChangedText(org, res.data.renewalNotResumed, true) : "",
                });
            }
            await onSaved();
        } catch (err) {
            setError(apiError(err));
            setSaving(false);
        }
    };

    const addAdmin = async () => {
        setError("");
        setNotice("");
        try {
            await api.post(`/org/admin/orgs/${org.OrgID}/org-admins`, admin);
            setAdmin({ firstName: "", lastName: "", email: "" });
            setNotice("Org admin login created. They set their password with “Forgot password” on the login page.");
        } catch (err) {
            setError(apiError(err));
        }
    };

    return (
        <OrgModal
            isOpen
            wide
            onClose={onClose}
            title={isNew ? "New organization" : `Edit ${org.OrgName}`}
            footer={<>
                <button type="button" className={s.btnSecondary} onClick={onClose}>Cancel</button>
                <button type="submit" form="org-editor" className={s.btnPrimary} disabled={saving}>
                    {saving && <Loader2 size={14} className="animate-spin" />} {isNew ? "Create organization" : "Save"}
                </button>
            </>}
        >
            <Alert onClose={() => setError("")}>{error}</Alert>
            <Alert kind="success" onClose={() => setNotice("")}>{notice}</Alert>
            <form id="org-editor" onSubmit={submit} className="grid gap-4 sm:grid-cols-2">
                {org.SignupRequest && (
                    <div className={`min-w-0 sm:col-span-2 rounded-xl border p-3 text-sm ${s.subPanel}`}>
                        <div className={`mb-1 text-xs font-semibold uppercase tracking-wide ${s.muted}`}>Sign-up request</div>
                        <p className={`whitespace-pre-line break-words ${s.body}`}>{org.SignupRequest}</p>
                    </div>
                )}
                <Field label="Organization name" htmlFor="oe-name" className="sm:col-span-2">
                    <input id="oe-name" className={s.input} value={form.orgName} onChange={set("orgName")} required maxLength={200} />
                </Field>
                {/* old <Field label="Type" htmlFor="oe-type" hint="Only Enterprise organizations can view student details."> */}
                {/* Community Partners follow the Enterprise rules */}
                {/* old <Field label="Type" htmlFor="oe-type" hint="Education organizations can't view student details."> */}
                <Field label="Type" htmlFor="oe-type" hint="Education organizations can't view client details.">
                    <select id="oe-type" className={s.input} value={form.orgType} onChange={onType} disabled={!!org.IsSystem}>
                        <option value="education">Education</option>
                        <option value="enterprise">Enterprise</option>
                        <option value="nonprofit">Community Partner</option>
                    </select>
                </Field>
                {form.orgType === "nonprofit" && (
                    <Field label="Kind of Community Partner" htmlFor="oe-partner">
                        <select id="oe-partner" className={s.input} value={form.partnerType} onChange={set("partnerType")}>
                            <option value="">Not set</option>
                            {Object.entries(PARTNER_TYPE_LABEL).map(([key, label]) => <option key={key} value={key}>{label}</option>)}
                        </select>
                    </Field>
                )}
                {!isNew && (
                    <>
                        {/* old <Field label="Status" htmlFor="oe-status" hint="Approving a pending organization activates its org admin login."> */}
                        {/* and what suspending does to its paid plans (they stop renewing; the paid time stays) */}
                        <Field label="Status" htmlFor="oe-status" hint={org.Status === "pending" ? "Approving a pending organization activates its org admin login."
                            : "Suspending stops its paid plans from renewing; it keeps the time it paid for, and reactivating turns renewal back on."}>
                        <select id="oe-status" className={s.input} value={form.status} onChange={set("status")} disabled={!!org.IsSystem}>
                            {/* old <option value="pending">Pending approval</option> */}
                            {/* Approval happens once: an approved org doesn't go back to pending, a pending one is approved or declined */}
                            {org.Status === "pending" && <option value="pending">Pending approval</option>}
                            <option value="active">Active</option>
                            {/* old <option value="suspended">Suspended</option> */}
                            {org.Status !== "pending" && <option value="suspended">Suspended</option>}
                        </select>
                    </Field>
                    </>
                )}
                {/* the numbers to start with; after that they change in the org's Licenses window */}
                {isNew ? (
                <>
                <Field label="Coach licenses" htmlFor="oe-coach">
                    <input id="oe-coach" type="number" min={0} className={s.input} value={form.coachLicenseLimit} onChange={set("coachLicenseLimit")} />
                </Field>
                {/* old <Field label="Student licenses" htmlFor="oe-student" hint="Per month."> */}
                <Field label="Client licenses" htmlFor="oe-student" hint="Per month.">
                    <input id="oe-student" type="number" min={0} className={s.input} value={form.studentLicenseLimit} onChange={set("studentLicenseLimit")} />
                </Field>
                </>
                ) : (
                    <div className={`flex flex-wrap items-center justify-between gap-2 rounded-xl border p-3 text-sm sm:col-span-2 ${s.subPanel}`}>
                        <span className={s.body}>
                            {/* old Licenses: <strong className={s.text}>{(current?.StudentLicenseLimit || 0) + (current?.StudentLicensesPurchased || 0)} student</strong> */}
                            Licenses: <strong className={s.text}>{(current?.StudentLicenseLimit || 0) + (current?.StudentLicensesPurchased || 0)} client</strong>
                            {" · "}<strong className={s.text}>{(current?.CoachLicenseLimit || 0) + (current?.CoachLicensesPurchased || 0)} coach</strong>
                        </span>
                        <button type="button" className={s.btnSm} onClick={() => onLicenses?.(org.OrgID)}>
                            <KeyRound size={14} /> Change licenses
                        </button>
                    </div>
                )}
                <Field label="Programs" htmlFor="oe-programs">
                    <input id="oe-programs" type="number" min={0} className={s.input} value={form.programLimit} onChange={set("programLimit")} />
                </Field>
                <Field label="Org admins" htmlFor="oe-admins" hint="Most org admins it can have. Blank = no limit.">
                    <input id="oe-admins" type="number" min={1} className={s.input} value={form.adminLimit} onChange={set("adminLimit")} />
                </Field>
                {/* old <Field label="Plan for licensed students" htmlFor="oe-stier" hint="Applies only when it's better than the student's own plan."> */}
                {/* A license now stacks with the student's own plan instead of replacing it: paid plans'
                    monthly uses add up, a free plan only sets a floor, features from either plan unlock */}
                {/* old <Field label="Plan for licensed students" htmlFor="oe-stier" hint="Stacks with the student's own plan: monthly uses from paid plans add up (a free plan doesn't add), and features from either plan unlock."> */}
                <Field label="Plan for licensed clients" htmlFor="oe-stier" hint="Stacks with the client's own plan: monthly uses from paid plans add up (a free plan doesn't add), and features from either plan unlock.">
                    <select id="oe-stier" className={s.input} value={form.sponsoredStudentTierId} onChange={set("sponsoredStudentTierId")}>
                        <option value="">None</option>
                        {studentTiers.map((t) => <option key={t.TierID} value={t.TierID}>{t.TierName}</option>)}
                    </select>
                </Field>
                <Field label="Plan for licensed coaches" htmlFor="oe-ctier">
                    <select id="oe-ctier" className={s.input} value={form.sponsoredCoachTierId} onChange={set("sponsoredCoachTierId")}>
                        <option value="">None</option>
                        {coachTiers.map((t) => <option key={t.TierID} value={t.TierID}>{t.TierName}</option>)}
                    </select>
                </Field>
                {/* its own Resume Checklist: its Checklists & Scoring page shows these rules and the code (Evan, Oct 9) */}
                <Field label="Resume Checklist" htmlFor="oe-checklist" className="sm:col-span-2"
                       //old hint="Its students enter this code as their Organization Code on Resume Checklist to get these rules. The organization sees them, and the code, on Checklists & Scoring.">
                       hint="Its clients enter this code as their Organization Code on Resume Checklist to get these rules. The organization sees them, and the code, on Checklists & Scoring.">
                    <select id="oe-checklist" className={s.input} value={form.checklistCode} onChange={set("checklistCode")}>
                        <option value="">Pono Pilot standard</option>
                        {(checklists || []).map((c) => (
                            <option key={c.Code} value={c.Code}>{c.OrgName ? `${c.Code} · ${c.OrgName}` : c.Code} ({c.RuleCount} rules)</option>
                        ))}
                    </select>
                </Field>
                <Field label="Primary contact" htmlFor="oe-contact">
                    <input id="oe-contact" className={s.input} value={form.primaryContactName} onChange={set("primaryContactName")} maxLength={200} />
                </Field>
                <Field label="Contact email" htmlFor="oe-cemail">
                    <input id="oe-cemail" type="email" className={s.input} value={form.primaryContactEmail} onChange={set("primaryContactEmail")} maxLength={255} />
                </Field>
                <Field label="Contact phone" htmlFor="oe-phone">
                    <input id="oe-phone" className={s.input} value={form.primaryContactPhone} onChange={set("primaryContactPhone")} maxLength={50} />
                </Field>
                <Field label="Billing contact (optional)" htmlFor="oe-bcontact" className="sm:col-span-2"
                       hint="Gets the payment and renewal emails too. No account needed. The organization can change it in its Settings.">
                    <input id="oe-bcontact" className={s.input} value={form.secondaryContactName} onChange={set("secondaryContactName")} maxLength={200} />
                </Field>
                <Field label="Billing email" htmlFor="oe-bemail">
                    <input id="oe-bemail" type="email" className={s.input} value={form.secondaryContactEmail} onChange={set("secondaryContactEmail")} maxLength={255} />
                </Field>
                <Field label="Billing phone" htmlFor="oe-bphone">
                    <input id="oe-bphone" className={s.input} value={form.secondaryContactPhone} onChange={set("secondaryContactPhone")} maxLength={50} />
                </Field>
            </form>

            <div className={`mt-6 rounded-xl border p-4 ${s.subPanel}`}>
                <h4 className={`mb-1 text-sm font-bold ${s.text}`}>{isNew ? "Org admin login (optional)" : "Add an org admin login"}</h4>
                <p className={`mb-3 text-xs ${s.muted}`}>Creates a login for someone who manages the organization. They set a password with “Forgot password”. The email can't already have a Pono Pilot account.</p>
                <div className="grid gap-3 sm:grid-cols-3">
                    <input aria-label="Org admin first name" placeholder="First name" className={s.input} value={admin.firstName}
                           onChange={(e) => setAdmin((a) => ({ ...a, firstName: e.target.value }))} />
                    <input aria-label="Org admin last name" placeholder="Last name" className={s.input} value={admin.lastName}
                           onChange={(e) => setAdmin((a) => ({ ...a, lastName: e.target.value }))} />
                    <input aria-label="Org admin email" type="email" placeholder="Email" className={s.input} value={admin.email}
                           onChange={(e) => setAdmin((a) => ({ ...a, email: e.target.value }))} />
                </div>
                {!isNew && (
                    <button type="button" className={`${s.btnSecondary} mt-3`} onClick={addAdmin}
                            disabled={!admin.firstName || !admin.lastName || !admin.email}>
                        <Plus size={14} /> Add org admin
                    </button>
                )}
            </div>
            {confirming && <ApproveConfirm org={org} onCancel={() => setConfirming(false)} onApprove={(extra) => submit(null, extra)} />}
        </OrgModal>
    );
}

// ── Scope picker (org or program) ────────────────────────────────────────────

// ── License requests ─────────────────────────────────────────────────────────

// Waiting for payment first: what Pono Pilot follows up (requests waiting for approval are only older ones)
const REQUEST_FILTERS = [
    //old { key: "pending", label: "Waiting for approval" },
    { key: "approved", label: "Waiting for payment" },
    { key: "active", label: "Active" },
    { key: "pending", label: "Waiting for approval" },
    { key: "", label: "All" },
];
const REQUEST_TONE = { pending: "warning", approved: "primary", active: "success", merged: "success", ended: "neutral", rejected: "danger", cancelled: "neutral" };
// A row's status in the filter's words
const REQUEST_LABEL = { pending: "Waiting for approval", approved: "Waiting for payment", active: "Active", merged: "Added to plan", ended: "Ended",
    rejected: "Declined", cancelled: "Cancelled" };
const money = (n) => `$${Number(n || 0).toFixed(2)}`;
const perPeriod = (billingMode) => (billingMode === "yearly" ? "per year" : "per month");

/** License requests: set up licenses for an organization (only Pono Pilot
 *  sets counts; the org pays next, or gets the seats right away when the tier has
 *  no group price), approve or decline older requests, cancel unpaid ones, change
 *  a plan's seats or renewal, or end active ones. */
function LicenseRequestsTab({ orgs, onChanged }) {
    const s = useOrgStyles();
    //old const [status, setStatus] = useState("pending");
    const [status, setStatus] = useState("approved");
    const [requests, setRequests] = useState(null);
    const [error, setError] = useState("");
    const [notice, setNotice] = useState("");
    const [busyId, setBusyId] = useState(null);
    //old const [settingUp, setSettingUp] = useState(false);
    //old const [seatsFor, setSeatsFor] = useState(null); // plan row whose seats are being changed
    // More or fewer licenses and renewal change in the org's Licenses window (JJ, Oct 23: one place)
    const [licensesFor, setLicensesFor] = useState(null);

    const load = useCallback(async () => {
        try {
            const res = await api.get("/org/admin/license-requests", { params: status ? { status } : {} });
            setRequests(res.data.requests || []);
        } catch (err) {
            setError(apiError(err, "Couldn't load license requests."));
            setRequests([]);
        }
    }, [status]);
    useEffect(() => { load(); }, [load]);

    const act = async (r, fn) => {
        setBusyId(r.RequestID);
        setError("");
        setNotice("");
        try {
            await fn();
            await load();
            onChanged();
        } catch (err) {
            setError(apiError(err));
        } finally {
            setBusyId(null);
        }
    };

    const approve = (r) => {
        const priced = r.TotalAmount != null && Number(r.TotalAmount) > 0;
        const msg = priced
            //old ? `Approve ${r.Quantity} ${r.LicenseType} licenses for ${r.OrgName}?\n\nThey'll be asked to pay ${money(r.TotalAmount)} ${perPeriod(r.BillingMode)} (renews automatically); the licenses are added once they pay.`
            ? `Approve ${r.Quantity} ${LICENSE_TYPE_LABEL[r.LicenseType]} licenses for ${r.OrgName}?\n\nThey'll be asked to pay ${money(r.TotalAmount)} ${perPeriod(r.BillingMode)} (renews automatically); the licenses are added once they pay.`
            //old : `Approve ${r.Quantity} ${r.LicenseType} licenses for ${r.OrgName}?\n\nThere's no group price, so the licenses are added right away and stay until you end them.`;
            : `Approve ${r.Quantity} ${LICENSE_TYPE_LABEL[r.LicenseType]} licenses for ${r.OrgName}?\n\nThere's no group price, so the licenses are added right away and stay until you end them.`;
        if (window.confirm(msg)) act(r, () => api.post(`/org/admin/license-requests/${r.RequestID}/review`, { approve: true }));
    };
    const decline = (r) => {
        const note = window.prompt(`Decline ${r.OrgName}'s request? Add a short reason they'll see (optional):`, "");
        if (note !== null) act(r, () => api.post(`/org/admin/license-requests/${r.RequestID}/review`, { approve: false, note }));
    };
    const end = (r) => {
        // "purchased" only for paid seats: seats set up for free were never bought
        //old const msg = `End ${r.OrgName}'s ${r.Quantity} ${r.TotalAmount > 0 ? "purchased " : ""}${r.LicenseType} licenses?\n\nThey keep them through the end of this month.${r.TotalAmount > 0 ? " The automatic payment stops now." : ""}`;
        // (only a plan has an automatic payment: End is left for one only when its organization was archived)
        //old const msg = `End ${r.OrgName}'s ${r.Quantity} ${r.TotalAmount > 0 ? "purchased " : ""}${r.LicenseType} licenses?\n\nThey keep them through the end of this month.${r.AutoRenews ? " The automatic payment stops now." : ""}`;
        const msg = `End ${r.OrgName}'s ${r.Quantity} ${r.TotalAmount > 0 ? "purchased " : ""}${LICENSE_TYPE_LABEL[r.LicenseType]} licenses?\n\nThey keep them through the end of this month.${r.AutoRenews ? " The automatic payment stops now." : ""}`;
        if (window.confirm(msg)) act(r, () => api.post(`/org/admin/license-requests/${r.RequestID}/end`));
    };
    // A request that isn't paid yet (e.g. set up with the wrong number). While it's
    // open, a new set-up for the same license type is refused.
    const cancel = (r) => {
        if (window.confirm("Cancel this request? The organization won't be asked to pay for it.")) {
            act(r, () => api.delete(`/org/${r.OrgID}/license-requests/${r.RequestID}`));
        }
    };
    // A plan's automatic renewal (the org admin can't change it). Off keeps the
    // licenses through the month the paid period ends in.
    //old const setRenewal = (r, renew) => {
    //old const ends = r.CurrentPeriodEnd ? formatDate(monthEnd(r.CurrentPeriodEnd)) : "the end of the paid period";
    //old const ok = renew || window.confirm(
    //old `Turn renewal off for ${r.OrgName}'s ${r.Quantity} ${r.LicenseType} licenses?\n\nThey won't be charged again. They keep the licenses until ${ends}, then they end.`);
    //old if (!ok) return;
    //old act(r, async () => {
    //old await api.post(`/org/${r.OrgID}/license-requests/${r.RequestID}/auto-renew`, { renew });
    //old setNotice(renew ? `Renewal is back on for ${r.OrgName}.` : `Renewal is off for ${r.OrgName}. The licenses last until ${ends}.`);
    //old });
    //old };
    // A new request is approved or active right away; show it under its own filter
    //old const onSetUp = async (request, orgName) => {
    //old setSettingUp(false);
    //old const qty = `${request?.Quantity ?? ""} ${request?.LicenseType ?? ""} licenses`.trim();
    //old setNotice(request?.Status === "active"
    //old ? `${qty} for ${orgName} are active now. They stay until you end them.`
    //old : `${qty} are set up for ${orgName}. They'll see Pay now on their Licenses page.`);
    //old if (REQUEST_FILTERS.some((f) => f.key === request?.Status) && request.Status !== status) setStatus(request.Status);
    //old else await load();
    //old onChanged();
    //old };

    return (
        <Panel
            title="License requests"
            actions={<>
                <select aria-label="Filter by status" className={`${s.input} max-w-[14rem]`} value={status} onChange={(e) => setStatus(e.target.value)}>
                    {REQUEST_FILTERS.map((f) => <option key={f.key} value={f.key}>{f.label}</option>)}
                </select>
                {/* old <button type="button" className={s.btnPrimary} onClick={() => { setNotice(""); setSettingUp(true); }}> */}
                {/* old <Plus size={16} /> Set up licenses */}
                {/* old </button> */}
            </>}
            padded={false}
        >
            <div className="px-5 pt-4">
                <Alert onClose={() => setError("")}>{error}</Alert>
                <Alert kind="success" onClose={() => setNotice("")}>{notice}</Alert>
            </div>
            {requests === null ? (
                <InlineTableSkeleton isDarkMode={s.dark} rows={4} cols={5} bordered={false} />
            ) : requests.length === 0 ? (
                <>
                {/* old body="Use Set up licenses to give an organization licenses; organizations can't ask for a number themselves. Prices come from the group pricing in Membership Management → Edit Tier." /> */}
                <EmptyState icon={KeyRound} title="No requests here"
                            body="Change an organization's licenses with Licenses on its row in the Organizations tab; organizations can't ask for a number themselves. Prices come from the group pricing in Membership Management → Edit Tier." />
                </>
            ) : (
                <div className="relative overflow-x-auto">
                    <table className="w-full">
                        <thead>
                            <tr className={`border-b ${s.dark ? "border-slate-700" : "border-slate-100"}`}>
                                <th className={s.th}>Organization</th>
                                <th className={s.th}>Licenses</th>
                                <th className={s.th}>Price</th>
                                <th className={s.th}>Status</th>
                                <th className={s.th}><span className="sr-only">Actions</span></th>
                            </tr>
                        </thead>
                        <tbody>
                            {requests.map((r) => (
                                <tr key={r.RequestID} className={`border-b last:border-0 ${s.row}`}>
                                    <td className={s.td}>
                                        <div className={`font-semibold ${s.text}`}>{r.OrgName}</div>
                                        <div className={`text-xs ${s.muted}`}>{r.RequestedBy || "Org admin"} · {formatDate(r.CreatedOn)}</div>
                                        {r.Note && <div className={`mt-1 text-xs ${s.body}`}>“{r.Note}”</div>}
                                    </td>
                                    <td className={s.td}>
                                        {/* old <div className={s.text}>{r.Quantity} {r.LicenseType}</div> */}
                                        <div className={s.text}>{r.Quantity} {LICENSE_TYPE_LABEL[r.LicenseType] || r.LicenseType}</div>
                                        {r.TierName && <div className={`text-xs ${s.muted}`}>{r.TierName}</div>}
                                    </td>
                                    <td className={`${s.td} whitespace-nowrap tabular-nums`}>
                                        {r.TotalAmount != null ? (
                                            <>
                                                {/* old <div className={s.text}>{money(r.TotalAmount)} {perPeriod(r.BillingMode)}</div> */}
                                                {/* (seats added to a plan can cost nothing more, never a negative amount) */}
                                                <div className={s.text}>{Number(r.TotalAmount) > 0 ? <>{money(r.TotalAmount)} {perPeriod(r.BillingMode)}</> : "No extra cost"}</div>
                                                <div className={`text-xs ${s.muted}`}>
                                                    {money(seatPrice(r.UnitPrice, r.PercentOff))} each
                                                    {Number(r.PercentOff) > 0 ? ` (${money(r.UnitPrice)} − ${Math.round(Number(r.PercentOff) * 100) / 100}%)` : ""}
                                                </div>
                                                {r.ScheduledQuantity != null && (
                                                    <div className={`text-xs ${s.muted}`}>
                                                        {r.Status === "active" ? `from next renewal (${r.ScheduledQuantity} licenses)` : `for ${r.ScheduledQuantity} licenses`}
                                                    </div>
                                                )}
                                            </>
                                        ) : <span className={s.muted}>No group price</span>}
                                    </td>
                                    <td className={s.td}>
                                        {/* old <Pill tone={REQUEST_TONE[r.Status]}>{r.Status === "merged" ? "added to plan" : r.Status}</Pill> */}
                                        <Pill tone={REQUEST_TONE[r.Status]}>{REQUEST_LABEL[r.Status] || r.Status}</Pill>
                                        {/* the day to pay by (the date the organization's emails say), or that it's over: paying is refused then */}
                                        {/* (or that its price changed since it was set up: paying is refused then too, as the
                                            organization's Licenses page says) */}
                                        {r.Status === "approved" && r.PayBy && (
                                            <div className={`mt-1 text-xs ${r.PayByPassed || r.QuoteChanged ? (s.dark ? "text-amber-300" : "text-amber-700") : s.muted}`}>
                                                {/* (for a plan whose own price changed since it was bought, the row's PlanChangeBlocked: nothing can
                                                    be added to the plan before it ends, so it isn't set up again, as the Licenses window says) */}
                                                {r.QuoteChanged && r.PlanChangeBlocked
                                                    ? "Cancel it: its plan can't get more licenses before it ends (stop the plan's renewal, then set up new ones once it ends)"
                                                    : r.QuoteChanged ? "Its price changed since it was set up: cancel it and set it up again"
                                                    : r.PayByPassed ? `Had to be paid by ${formatDate(r.PayBy)}: cancel it and set it up again` : `Pay by ${formatDate(r.PayBy)}`}
                                            </div>
                                        )}
                                        {r.PaidOn && <div className={`mt-1 text-xs ${s.muted}`}>Paid {formatDate(r.PaidOn)}</div>}
                                        {/* old {r.Status === "active" && !!r.CancelAtPeriodEnd && <div className={`mt-1 text-xs ${s.muted}`}>Renewal off</div>} */}
                                        {/* a plan's next renewal, or when it ends once its renewal is off (the Licenses window's words) */}
                                        {r.Status === "active" && !!r.AutoRenews && (
                                            <div className={`mt-1 text-xs ${s.muted}`}>
                                                {r.CancelAtPeriodEnd ? `Renewal is off${r.CurrentPeriodEnd ? ` · ends ${formatDate(monthEnd(r.CurrentPeriodEnd))}` : ""}`
                                                    : r.CurrentPeriodEnd ? `Renews ${formatDate(r.CurrentPeriodEnd)}` : "Renews automatically"}
                                            </div>
                                        )}
                                    </td>
                                    <td className={`${s.td} text-right`}>
                                        <div className="flex justify-end gap-1">
                                            {r.Status === "pending" && <>
                                                <button type="button" className={s.btnSm} disabled={busyId === r.RequestID} onClick={() => approve(r)}><CheckCircle2 size={14} /> Approve</button>
                                                <button type="button" className={s.btnDanger} disabled={busyId === r.RequestID} onClick={() => decline(r)}>Decline</button>
                                            </>}
                                            {(r.Status === "pending" || r.Status === "approved") && (
                                                <button type="button" className={s.btnDanger} disabled={busyId === r.RequestID} onClick={() => cancel(r)}>Cancel</button>
                                            )}
                                            {/* old {r.Status === "active" && !!r.AutoRenews && !r.CancelAtPeriodEnd && ( */}
                                            {/* old <button type="button" className={s.btnSm} disabled={busyId === r.RequestID} onClick={() => setSeatsFor(r)}>Change seats</button> */}
                                            {/* old )} */}
                                            {/* old {r.Status === "active" && !!r.AutoRenews && ( */}
                                            {/* old <button type="button" className={s.btnSm} disabled={busyId === r.RequestID} onClick={() => setRenewal(r, !!r.CancelAtPeriodEnd)}> */}
                                            {/* old {r.CancelAtPeriodEnd ? "Turn renewal on" : "Turn renewal off"} */}
                                            {/* old </button> */}
                                            {/* old )} */}
                                            {/* the number of licenses and renewal: the org's Licenses window (not for an archived
                                                org, which isn't in the list: End still ends its seats) */}
                                            {(orgs || []).some((o) => o.OrgID === r.OrgID) && (
                                                <button type="button" className={s.btnSm} disabled={busyId === r.RequestID} onClick={() => setLicensesFor(r.OrgID)}>
                                                    <KeyRound size={14} /> Licenses
                                                </button>
                                            )}
                                            {/* old {r.Status === "active" && ( */}
                                            {/* A paid plan stops at its renewal in the Licenses window, keeping the time paid for (Evan, Sep 9: a
                                                downgrade waits for the end of the paid period); stopping one now with a refund is done in Stripe's
                                                dashboard and comes back through its webhook. End stays for licenses added outside a plan, and for
                                                a plan an archived organization left running (it has no Licenses window) */}
                                            {r.Status === "active" && (!r.AutoRenews || !(orgs || []).some((o) => o.OrgID === r.OrgID)) && (
                                                <button type="button" className={s.btnDanger} disabled={busyId === r.RequestID} onClick={() => end(r)}>End</button>
                                            )}
                                        </div>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            )}
            {/* old {settingUp && <SetUpLicensesModal orgs={orgs} onClose={() => setSettingUp(false)} onDone={onSetUp} />} */}
            {/* old {seatsFor && ( */}
            {/* old <PlanSeatsModal plan={seatsFor} onClose={() => setSeatsFor(null)} */}
            {/* old onSaved={async (seats) => { */}
            {/* old const plan = seatsFor; */}
            {/* old setSeatsFor(null); */}
            {/* old setNotice(seats === plan.Quantity */}
            {/* old ? `${plan.OrgName}'s plan keeps its ${plan.Quantity} licenses.` */}
            {/* old : `From ${plan.CurrentPeriodEnd ? formatDate(plan.CurrentPeriodEnd) : "the next renewal"}, ${plan.OrgName}'s plan has ${seats} licenses.`); */}
            {/* old await load(); */}
            {/* old onChanged(); */}
            {/* old }} /> */}
            {/* old )} */}
            {licensesFor && (
                <LicensesModal orgId={licensesFor} onClose={() => setLicensesFor(null)} onChanged={() => { load(); onChanged(); }} />
            )}
        </Panel>
    );
}

/** Pono Pilot sets up licenses for an organization: the request is
 *  created already approved, priced from the org's group pricing (the org admin
 *  then pays on their Licenses page), or active right away when there's no price. */
// No longer opened: the org's Licenses window replaced it (JJ, Oct 23)
// eslint-disable-next-line no-unused-vars
function SetUpLicensesModal({ orgs, onClose, onDone }) {
    const s = useOrgStyles();
    const activeOrgs = orgs.filter((o) => o.Status === "active");
    const [form, setForm] = useState({ orgId: "", licenseType: "student", quantity: "", note: "" });
    const [orgData, setOrgData] = useState(null); // { pricing, requests } of the chosen org
    const [saving, setSaving] = useState(false);
    const [error, setError] = useState("");
    const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

    // The chosen org's group pricing and current requests, for the price shown below
    useEffect(() => {
        setOrgData(null);
        if (!form.orgId) return undefined;
        let cancelled = false;
        api.get(`/org/${form.orgId}/license-requests`)
            .then((res) => { if (!cancelled) setOrgData({ pricing: res.data.pricing || {}, requests: res.data.requests || [] }); })
            .catch(() => { if (!cancelled) setOrgData({ pricing: {}, requests: [] }); });
        return () => { cancelled = true; };
    }, [form.orgId]);

    const quantity = Math.max(0, Math.min(1000, parseInt(form.quantity, 10) || 0));
    const pricing = orgData?.pricing?.[form.licenseType] || null;
    const plan = (orgData?.requests || []).find((r) => r.LicenseType === form.licenseType && r.Status === "active" && r.AutoRenews);
    const openRequest = (orgData?.requests || []).find((r) => r.LicenseType === form.licenseType && (r.Status === "pending" || r.Status === "approved"));
    // Same math as the backend: with a plan, the discount step follows the plan's new total
    const planSeats = plan ? (plan.ScheduledQuantity ?? plan.Quantity) : 0;
    const q = pricing && quantity > 0 ? quote(pricing, planSeats + quantity) : null;
    const period = pricing?.BillingMode === "yearly" ? "per year" : "per month";
    // What these seats add to the bill: the plan's new total less what it bills now (a discount step
    // the new total reaches covers the seats it has too), as the backend prices it
    const added = q && plan ? Math.round((q.total - Number(plan.TotalAmount || 0)) * 100) / 100 : null;
    // A number that costs more than a bigger one isn't sold (the backend refuses it the same way)
    const cheaper = q ? (pricing.Discounts || []).map((d) => Number(d.MinQuantity)).filter((m) => m > planSeats + quantity)
        .sort((x, y) => x - y).map((m) => ({ seats: m, total: quote(pricing, m).total })).find((c) => c.total < q.total) : null;

    const submit = async (e) => {
        e.preventDefault();
        setSaving(true);
        setError("");
        try {
            const res = await api.post(`/org/admin/orgs/${form.orgId}/license-requests`, {
                licenseType: form.licenseType, quantity, note: form.note.trim() || undefined,
            });
            const orgName = activeOrgs.find((o) => String(o.OrgID) === String(form.orgId))?.OrgName || "the organization";
            await onDone(res.data.request, orgName);
        } catch (err) {
            setError(apiError(err));
            setSaving(false);
        }
    };

    return (
        <OrgModal
            isOpen
            onClose={onClose}
            title="Set up licenses"
            footer={<>
                <button type="button" className={s.btnSecondary} onClick={onClose}>Cancel</button>
                {/* old <button type="submit" form="setup-licenses" className={s.btnPrimary} disabled={saving || !form.orgId || quantity < 1}> */}
                <button type="submit" form="setup-licenses" className={s.btnPrimary} disabled={saving || !form.orgId || quantity < 1 || Boolean(cheaper)}>
                    {saving && <Loader2 size={14} className="animate-spin" />} Set up licenses
                </button>
            </>}
        >
            <Alert onClose={() => setError("")}>{error}</Alert>
            <form id="setup-licenses" onSubmit={submit} className="space-y-4">
                <Field label="Organization" htmlFor="sl-org">
                    <select id="sl-org" className={s.input} value={form.orgId} onChange={set("orgId")} required>
                        <option value="">Choose an organization…</option>
                        {activeOrgs.map((o) => <option key={o.OrgID} value={o.OrgID}>{o.OrgName}</option>)}
                    </select>
                </Field>
                <div className="grid gap-4 sm:grid-cols-2">
                    <Field label="License type" htmlFor="sl-type">
                        <select id="sl-type" className={s.input} value={form.licenseType} onChange={set("licenseType")}>
                            {/* old <option value="student">Student</option> */}
                            <option value="student">Client</option>
                            <option value="coach">Coach</option>
                        </select>
                    </Field>
                    <Field label="How many" htmlFor="sl-qty">
                        <input id="sl-qty" type="number" min="1" max="1000" required className={s.input} value={form.quantity} onChange={set("quantity")} />
                    </Field>
                </div>
                {form.orgId && orgData && (
                    <div className={`rounded-xl border p-3 text-sm ${s.subPanel} ${s.body}`}>
                        {!pricing ? (
                            //old <p>There's no group price for {form.licenseType} licenses, so they're added right away and stay until you end them.</p>
                            <p>There's no group price for {LICENSE_TYPE_LABEL[form.licenseType]} licenses, so they're added right away and stay until you end them.</p>
                        ) : !q ? (
                            <p>{money(pricing.UnitPrice)} per license {period}, less volume discounts.</p>
                        ) : (
                            <p>
                                {/* old {plan ? <>Their plan goes from {planSeats} to <strong className={s.text}>{planSeats + quantity}</strong> licenses: these {quantity} add </> : <>They pay </>} */}
                                {/* old <strong className={s.text}>{money(seatTotal(q.each, quantity))}</strong> {period} ({money(q.each)} each */}
                                {plan ? (
                                    <>Their plan goes from {planSeats} to <strong className={s.text}>{planSeats + quantity}</strong> licenses
                                        {added > 0 ? <>: these {quantity} add <strong className={s.text}>{money(added)}</strong> {period}</> : <>, at no extra cost</>}.
                                        {" "}The plan is then <strong className={s.text}>{money(q.total)}</strong> {period} ({money(q.each)} each</>
                                ) : <>They pay <strong className={s.text}>{money(seatTotal(q.each, quantity))}</strong> {period} ({money(q.each)} each</>}
                                {q.pct > 0 ? `, ${Math.round(Number(q.pct) * 100) / 100}% off` : ""}).
                                {" "}The licenses are added once they pay on their Licenses page{plan ? " (charged for the rest of this billing period)" : ""}.
                            </p>
                        )}
                        {cheaper && (
                            <p className={`mt-2 ${s.dark ? "text-amber-300" : "text-amber-700"}`}>
                                {planSeats + quantity} licenses would cost {money(q.total)} {period}, more than {cheaper.seats} ({money(cheaper.total)}),
                                because the {cheaper.seats}+ discount covers every license. Set up {cheaper.seats - planSeats} instead.
                            </p>
                        )}
                        {openRequest && (
                            <p className={`mt-2 ${s.dark ? "text-amber-300" : "text-amber-700"}`}>
                                This organization already has {openRequest.Status === "pending" ? "a pending" : "an approved, unpaid"} request
                                {/* old for {openRequest.Quantity} {form.licenseType} licenses. Approve, decline or cancel it first. */}
                                {" "}for {openRequest.Quantity} {LICENSE_TYPE_LABEL[form.licenseType]} licenses. Approve, decline or cancel it first.
                            </p>
                        )}
                    </div>
                )}
                <Field label="Note (optional)" htmlFor="sl-note" hint="For Pono Pilot's records, e.g. what was agreed with the organization.">
                    <textarea id="sl-note" rows={2} maxLength={500} className={s.input} value={form.note} onChange={set("note")} />
                </Field>
            </form>
        </OrgModal>
    );
}

/** Fewer seats on an org's plan from its next renewal (the backend only lowers;
 *  adding goes through Set up licenses). */
// No longer opened: the org's Licenses window replaced it (JJ, Oct 23)
// eslint-disable-next-line no-unused-vars
function PlanSeatsModal({ plan, onClose, onSaved }) {
    const s = useOrgStyles();
    const [seats, setSeats] = useState(String(plan.ScheduledQuantity ?? plan.Quantity));
    const [saving, setSaving] = useState(false);
    const [error, setError] = useState("");

    const submit = async (e) => {
        e.preventDefault();
        setSaving(true);
        setError("");
        try {
            await api.post(`/org/${plan.OrgID}/license-requests/${plan.RequestID}/seats`, { seats: Number(seats) });
            await onSaved(Number(seats));
        } catch (err) {
            setError(apiError(err));
            setSaving(false);
        }
    };

    return (
        <OrgModal
            isOpen
            onClose={onClose}
            title={`Change seats: ${plan.OrgName}`}
            footer={<>
                <button type="button" className={s.btnSecondary} onClick={onClose}>Cancel</button>
                <button type="submit" form="plan-seats" className={s.btnPrimary} disabled={saving || !seats}>
                    {saving && <Loader2 size={14} className="animate-spin" />} Save
                </button>
            </>}
        >
            <Alert onClose={() => setError("")}>{error}</Alert>
            <form id="plan-seats" onSubmit={submit} className="space-y-4">
                <p className={`text-sm ${s.body}`}>
                    {/* old Their plan has <strong className={s.text}>{plan.Quantity} {plan.LicenseType} licenses</strong> */}
                    Their plan has <strong className={s.text}>{plan.Quantity} {LICENSE_TYPE_LABEL[plan.LicenseType]} licenses</strong>
                    {plan.CurrentPeriodEnd ? <> and renews on <strong className={s.text}>{formatDate(plan.CurrentPeriodEnd)}</strong></> : null}.
                </p>
                <Field label="Licenses from the next renewal" htmlFor="ps-seats"
                       hint={`Fewer licenses start at the next renewal; they keep all ${plan.Quantity} until then and aren't refunded. To add licenses, use Set up licenses.`}>
                    <input id="ps-seats" type="number" min="1" max={plan.Quantity} required className={s.input}
                           value={seats} onChange={(e) => setSeats(e.target.value)} />
                </Field>
            </form>
        </OrgModal>
    );
}

function ScopePicker({ orgs, programs, value, onChange, idPrefix }) {
    const s = useOrgStyles();
    const encoded = value.orgId ? `org:${value.orgId}` : value.programId ? `program:${value.programId}` : "";
    const byOrg = useMemo(() => {
        const map = new Map();
        programs.forEach((p) => {
            if (!map.has(p.OrgID)) map.set(p.OrgID, { name: p.OrgName, programs: [] });
            map.get(p.OrgID).programs.push(p);
        });
        return map;
    }, [programs]);
    return (
        <select id={`${idPrefix}-scope`} className={s.input} value={encoded}
                onChange={(e) => {
                    const [kind, id] = e.target.value.split(":");
                    onChange(kind === "org" ? { orgId: Number(id), programId: null } : kind === "program" ? { orgId: null, programId: Number(id) } : { orgId: null, programId: null });
                }}>
            <option value="">Choose an organization or program…</option>
            <optgroup label="Whole organization">
                {orgs.map((o) => <option key={`o${o.OrgID}`} value={`org:${o.OrgID}`}>{o.OrgName}</option>)}
            </optgroup>
            {[...byOrg.entries()].map(([orgId, g]) => (
                <optgroup key={orgId} label={`${g.name}: programs`}>
                    {g.programs.map((p) => <option key={`p${p.ProgramID}`} value={`program:${p.ProgramID}`}>{p.ProgramName}</option>)}
                </optgroup>
            ))}
        </select>
    );
}

// ScopePicker with each program's cohorts after it, so an assessment can go to one
// cohort (Evan, Oct 9). Custom evaluations keep ScopePicker: they aren't per cohort.
function AssessmentScopePicker({ orgs, programs, cohorts, value, onChange, idPrefix }) {
    const s = useOrgStyles();
    const encoded = value.orgId ? `org:${value.orgId}` : value.programId ? `program:${value.programId}` : value.cohortId ? `cohort:${value.cohortId}` : "";
    const byOrg = useMemo(() => {
        const map = new Map();
        programs.forEach((p) => {
            if (!map.has(p.OrgID)) map.set(p.OrgID, { name: p.OrgName, programs: [] });
            map.get(p.OrgID).programs.push({ ...p, cohorts: cohorts.filter((c) => c.ProgramID === p.ProgramID) });
        });
        return map;
    }, [programs, cohorts]);
    return (
        <select id={`${idPrefix}-scope`} className={s.input} value={encoded}
                onChange={(e) => {
                    const [kind, id] = e.target.value.split(":");
                    onChange(kind === "org" ? { orgId: Number(id), programId: null, cohortId: null }
                        : kind === "program" ? { orgId: null, programId: Number(id), cohortId: null }
                            : kind === "cohort" ? { orgId: null, programId: null, cohortId: Number(id) }
                                : { orgId: null, programId: null, cohortId: null });
                }}>
            <option value="">Choose an organization, program or cohort…</option>
            <optgroup label="Whole organization">
                {orgs.map((o) => <option key={`o${o.OrgID}`} value={`org:${o.OrgID}`}>{o.OrgName}</option>)}
            </optgroup>
            {[...byOrg.entries()].map(([orgId, g]) => (
                <optgroup key={orgId} label={`${g.name}: programs and cohorts`}>
                    {g.programs.flatMap((p) => [
                        <option key={`p${p.ProgramID}`} value={`program:${p.ProgramID}`}>{p.ProgramName}</option>,
                        ...p.cohorts.map((c) => <option key={`c${c.CohortID}`} value={`cohort:${c.CohortID}`}>{`${p.ProgramName} · ${c.CohortName}`}</option>),
                    ])}
                </optgroup>
            ))}
        </select>
    );
}

function scopeLabel(row) {
    if (row.CohortID) return `${row.OrgName} → ${row.ProgramName} · ${row.CohortName}`;
    return row.ProgramID ? `${row.OrgName} → ${row.ProgramName}` : `${row.OrgName} (whole organization)`;
}

// ── Change requests ──────────────────────────────────────────────────────────

const CHANGE_FILTERS = [
    { key: "pending", label: "New" },
    { key: "in_progress", label: "In progress" },
    { key: "done", label: "Done" },
    { key: "rejected", label: "Declined" },
    { key: "", label: "All" },
];
// The buttons that move a request on (each request shows the ones it isn't at)
const CHANGE_ACTIONS = [
    { status: "in_progress", label: "In progress" },
    { status: "done", label: "Done" },
    { status: "rejected", label: "Decline" },
];

/** Change requests org admins send from their Checklists & Scoring page (Evan,
 *  Oct 9): set each one in progress, done or declined, with an optional note the
 *  organization sees there. Nothing is emailed. */
function ChangeRequestsTab({ onChanged }) {
    const s = useOrgStyles();
    const [status, setStatus] = useState("pending");
    const [requests, setRequests] = useState(null);
    const [error, setError] = useState("");
    const [busyId, setBusyId] = useState(null);
    // what Approve on a More licenses request set up
    const [notice, setNotice] = useState("");

    const load = useCallback(async () => {
        try {
            const res = await api.get("/org/admin/change-requests", { params: status ? { status } : {} });
            setRequests(res.data.requests || []);
        } catch (err) {
            setError(apiError(err, "Couldn't load change requests."));
            setRequests([]);
        }
    }, [status]);
    useEffect(() => { load(); }, [load]);

    const move = async (r, next) => {
        // Cancel leaves the request as it is
        const note = window.prompt("Note for the organization (optional):", r.ReviewNote || "");
        if (note === null) return;
        setBusyId(r.ChangeRequestID);
        setError("");
        try {
            await api.post(`/org/admin/change-requests/${r.ChangeRequestID}/status`, { status: next, note });
            await load();
            onChanged();
        } catch (err) {
            setError(apiError(err));
        } finally {
            setBusyId(null);
        }
    };

    // Approve on a More licenses request (JJ, Nov 2): asked first, then its licenses are set up exactly as Change
    // licenses in the Licenses window sets them up (the organization pays on its Licenses page; with no price set
    // they're added now), and it says what it did, as the window does
    const approve = async (r) => {
        const label = LICENSE_TYPE_LABEL[r.LicenseType] || r.LicenseType;
        if (!window.confirm(`Approve ${r.OrgName}'s request for ${r.Quantity} more ${label} licenses?\n\nThey're set up the way Change licenses `
            + `sets them up: ${r.OrgName} pays for them on its Licenses page, or, with no price set, they're added now.`)) return;
        setBusyId(r.ChangeRequestID);
        setError("");
        setNotice("");
        try {
            const res = await api.post(`/org/admin/change-requests/${r.ChangeRequestID}/approve`);
            const lr = res.data.licenseRequest || {};
            const n = Number(lr.Quantity);
            const what = `${n} ${LICENSE_TYPE_LABEL[lr.LicenseType] || label} ${n === 1 ? "license" : "licenses"}`;
            setNotice(lr.Status === "active" ? `${what} ${n === 1 ? "was" : "were"} added for ${r.OrgName}. They're ready to assign.`
                : `${what} ${n === 1 ? "is" : "are"} set up for ${r.OrgName}. It sees ${lr.AddsToPlan ? "“Add to my plan”" : "Pay now"} on its Licenses page.`);
            await load();
            onChanged();
        } catch (err) {
            setError(apiError(err));
        } finally {
            setBusyId(null);
        }
    };

    return (
        <Panel
            title="Change requests"
            actions={
                <select aria-label="Filter by status" className={`${s.input} max-w-[14rem]`} value={status} onChange={(e) => setStatus(e.target.value)}>
                    {CHANGE_FILTERS.map((f) => <option key={f.key} value={f.key}>{f.label}</option>)}
                </select>
            }
            padded={false}
        >
            <div className="px-5 pt-4">
                <Alert onClose={() => setError("")}>{error}</Alert>
                <Alert kind="success" onClose={() => setNotice("")}>{notice}</Alert>
            </div>
            {requests === null ? (
                <InlineTableSkeleton isDarkMode={s.dark} rows={4} cols={5} bordered={false} />
            ) : requests.length === 0 ? (
                <EmptyState icon={MessageSquare} title="No requests here"
                            //old body="Organization admins send these from their Checklists & Scoring page." />
                            // (the form moved to the org's own Requests page, Evan Oct 16)
                            body="Organization admins send these from their Requests page." />
            ) : (
                <div className="relative overflow-x-auto">
                    <table className="w-full">
                        <thead>
                            <tr className={`border-b ${s.dark ? "border-slate-700" : "border-slate-100"}`}>
                                <th className={s.th}>Organization</th>
                                <th className={s.th}>About</th>
                                <th className={s.th}>Request</th>
                                <th className={s.th}>Status</th>
                                <th className={s.th}><span className="sr-only">Actions</span></th>
                            </tr>
                        </thead>
                        <tbody>
                            {requests.map((r) => (
                                <tr key={r.ChangeRequestID} className={`border-b last:border-0 ${s.row}`}>
                                    <td className={s.td}>
                                        <div className={`font-semibold ${s.text}`}>{r.OrgName}</div>
                                        <div className={`text-xs ${s.muted}`}>
                                            {[r.RequestedBy || "Org admin", r.RequestedByEmail !== r.RequestedBy && r.RequestedByEmail, formatDate(r.CreatedOn)]
                                                .filter(Boolean).join(" · ")}
                                        </div>
                                    </td>
                                    <td className={s.td}>
                                        <div className={s.text}>{FEATURE_LABEL[r.FeatureName] || r.FeatureName}</div>
                                        {r.TargetItem && <div className={`mt-1 max-w-xs break-words text-xs ${s.muted}`}>{r.TargetItem}</div>}
                                    </td>
                                    <td className={s.td}>
                                        <div className="min-w-[14rem] max-w-md whitespace-pre-wrap break-words">{r.Details}</div>
                                        {/* the PDF the organization attached */}
                                        {r.AttachmentFileName && (
                                            <button type="button" className={`${s.btnLink} mt-1 inline-flex max-w-md items-start gap-1 text-left !text-xs`}
                                                    onClick={() => downloadChangeRequestAttachment(r.OrgID, r.ChangeRequestID, r.AttachmentFileName)
                                                        .catch((err) => setError(apiError(err)))}>
                                                <Paperclip size={12} className="mt-0.5 shrink-0" aria-hidden="true" />
                                                <span className="[overflow-wrap:anywhere]">{r.AttachmentFileName}</span>
                                            </button>
                                        )}
                                    </td>
                                    <td className={s.td}>
                                        <Pill tone={(CHANGE_STATUS[r.Status] || {}).tone}>{(CHANGE_FILTERS.find((f) => f.key === r.Status) || {}).label || r.Status}</Pill>
                                        {r.ReviewNote && <div className={`mt-1 max-w-xs whitespace-pre-wrap break-words text-xs ${s.body}`}>{r.ReviewNote}</div>}
                                    </td>
                                    <td className={`${s.td} text-right`}>
                                        <div className="flex justify-end gap-1">
                                            {/* old {CHANGE_ACTIONS.filter((a) => a.status !== r.Status).map((a) => ( */}
                                            {/* a More licenses request has Approve (it sets the licenses up) and Decline, while it's new */}
                                            {r.FeatureName === "more_licenses" ? (r.Status === "pending" && <>
                                                <button type="button" className={s.btnSm} disabled={busyId === r.ChangeRequestID} onClick={() => approve(r)}>
                                                    Approve
                                                </button>
                                                <button type="button" className={s.btnDanger} disabled={busyId === r.ChangeRequestID} onClick={() => move(r, "rejected")}>
                                                    Decline
                                                </button>
                                            </>) : CHANGE_ACTIONS.filter((a) => a.status !== r.Status).map((a) => (
                                                <button key={a.status} type="button" className={a.status === "rejected" ? s.btnDanger : s.btnSm}
                                                        disabled={busyId === r.ChangeRequestID} onClick={() => move(r, a.status)}>
                                                    {a.label}
                                                </button>
                                            ))}
                                        </div>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            )}
        </Panel>
    );
}

// ── Assessments ──────────────────────────────────────────────────────────────

function AssessmentsTab({ options, orgs }) {
    const s = useOrgStyles();
    const [rows, setRows] = useState(null);
    const [surveyId, setSurveyId] = useState("");
    //old const [scope, setScope] = useState({ orgId: null, programId: null });
    const [scope, setScope] = useState({ orgId: null, programId: null, cohortId: null });
    const [error, setError] = useState("");
    const [busy, setBusy] = useState(false);

    const load = useCallback(async () => {
        try {
            const res = await api.get("/org/admin/survey-assignments");
            setRows(res.data.assignments || []);
        } catch (err) {
            setError(apiError(err, "Couldn't load assignments."));
            setRows([]);
        }
    }, []);
    useEffect(() => { load(); }, [load]);

    const assign = async (e) => {
        e.preventDefault();
        setBusy(true);
        setError("");
        try {
            await api.post("/org/admin/survey-assignments", { surveyId: Number(surveyId), ...scope });
            setSurveyId("");
            await load();
        } catch (err) {
            setError(apiError(err));
        } finally {
            setBusy(false);
        }
    };

    const remove = async (row) => {
        if (!window.confirm(`Remove "${row.Title}" from ${scopeLabel(row)}? Responses already submitted are kept.`)) return;
        try {
            await api.delete(`/org/admin/survey-assignments/${row.SurveyAssignmentID}`);
            await load();
        } catch (err) { setError(apiError(err)); }
    };

    return (
        <div className="grid gap-6 lg:grid-cols-3">
            <Panel title="Assign an assessment or survey">
                <p className={`mb-4 text-sm ${s.muted}`}>
                    Build it in <Link to="/admin/surveys" className={s.btnLink}>Survey Management</Link>, then assign it here.
                    {/* old Assigned surveys appear under My Coaching → Programs for those students only and no longer pop up for everyone. */}
                    {" "}Assigned surveys appear under My Coaching → Programs for those clients only and no longer pop up for everyone.
                </p>
                <Alert onClose={() => setError("")}>{error}</Alert>
                <form onSubmit={assign} className="space-y-4">
                    <Field label="Survey" htmlFor="as-survey">
                        <select id="as-survey" className={s.input} value={surveyId} onChange={(e) => setSurveyId(e.target.value)} required>
                            <option value="">Choose a survey…</option>
                            {options.surveys.map((sv) => <option key={sv.SurveyID} value={sv.SurveyID}>{sv.Title}{sv.IsActive ? "" : " (inactive)"}</option>)}
                        </select>
                    </Field>
                    <Field label="Assign to" htmlFor="as-scope">
                        {/* old <ScopePicker orgs={orgs} programs={options.programs} value={scope} onChange={setScope} idPrefix="as" /> */}
                        <AssessmentScopePicker orgs={orgs} programs={options.programs} cohorts={options.cohorts || []} value={scope} onChange={setScope} idPrefix="as" />
                    </Field>
                    {/* old <button type="submit" className={`${s.btnPrimary} w-full`} disabled={busy || !surveyId || !(scope.orgId || scope.programId)}> */}
                    <button type="submit" className={`${s.btnPrimary} w-full`} disabled={busy || !surveyId || !(scope.orgId || scope.programId || scope.cohortId)}>
                        {busy && <Loader2 size={14} className="animate-spin" />} Assign
                    </button>
                </form>
            </Panel>
            <Panel title="Assignments" padded={false} className="lg:col-span-2">
                {!rows ? (
                    <div className="flex justify-center py-10"><Loader2 className={`animate-spin ${s.muted}`} /></div>
                ) : rows.length === 0 ? (
                    //old <EmptyState icon={ClipboardList} title="Nothing assigned yet" body="Every student can take the standard Pono Pilot assessments. Assign extra ones to an organization or program here." />
                    //old <EmptyState icon={ClipboardList} title="Nothing assigned yet" body="Every student can take the standard Pono Pilot assessments. Assign extra ones to an organization, program or cohort here." />
                    <EmptyState icon={ClipboardList} title="Nothing assigned yet" body="Every client can take the standard Pono Pilot assessments. Assign extra ones to an organization, program or cohort here." />
                ) : (
                    <ul className={`divide-y ${s.divider}`}>
                        {rows.map((r) => (
                            <li key={r.SurveyAssignmentID} className="flex items-center justify-between gap-3 px-5 py-3">
                                <div className="min-w-0">
                                    <div className={`font-semibold ${s.text}`}>{r.Title}</div>
                                    <div className={`text-xs ${s.muted}`}>{scopeLabel(r)}</div>
                                </div>
                                <button type="button" className={s.btnDanger} onClick={() => remove(r)} aria-label={`Remove ${r.Title}`}><Trash2 size={14} /></button>
                            </li>
                        ))}
                    </ul>
                )}
            </Panel>
        </div>
    );
}

// ── Custom evaluations ───────────────────────────────────────────────────────

function EvaluationsTab({ options, orgs }) {
    const s = useOrgStyles();
    const [rows, setRows] = useState(null);
    const [error, setError] = useState("");
    const [editing, setEditing] = useState(null); // null | {} | {EvaluationID}

    const load = useCallback(async () => {
        try {
            const res = await api.get("/org/admin/evaluations");
            setRows(res.data.evaluations || []);
        } catch (err) {
            setError(apiError(err, "Couldn't load evaluations."));
            setRows([]);
        }
    }, []);
    useEffect(() => { load(); }, [load]);

    const remove = async (row) => {
        if (!window.confirm(`Archive "${row.Name}"? ${scopeLabel(row)} goes back to the default Pono Pilot ${row.EvaluationType} scoring.`)) return;
        try {
            await api.delete(`/org/admin/evaluations/${row.EvaluationID}`);
            await load();
        } catch (err) { setError(apiError(err)); }
    };

    return (
        <>
            <Alert onClose={() => setError("")}>{error}</Alert>
            <Panel
                title="Custom resume & interview evaluations"
                padded={false}
                actions={<button type="button" className={s.btnPrimary} onClick={() => setEditing({})}><Plus size={16} /> New evaluation</button>}
            >
                <p className={`px-5 pt-4 text-sm ${s.muted}`}>
                    {/* old Students in the organization or program can choose these criteria when they review a resume or practice an interview. */}
                    Clients in the organization or program can choose these criteria when they review a resume or practice an interview.
                    A program's evaluation takes priority over its organization's.
                </p>
                {!rows ? (
                    <div className="flex justify-center py-10"><Loader2 className={`animate-spin ${s.muted}`} /></div>
                ) : rows.length === 0 ? (
                    <EmptyState icon={SlidersHorizontal} title="No custom evaluations" body="Everyone is scored with the default Pono Pilot categories." />
                ) : (
                    <div className="relative overflow-x-auto">
                        <table className="w-full">
                            <thead>
                                <tr className={`border-b ${s.dark ? "border-slate-700" : "border-slate-100"}`}>
                                    <th className={s.th}>Evaluation</th>
                                    <th className={s.th}>Type</th>
                                    <th className={s.th}>Applies to</th>
                                    <th className={s.th}>Categories</th>
                                    <th className={s.th}><span className="sr-only">Actions</span></th>
                                </tr>
                            </thead>
                            <tbody>
                                {rows.map((r) => (
                                    <tr key={r.EvaluationID} className={`border-b last:border-0 ${s.row}`}>
                                        <td className={s.td}>
                                            <div className={`font-semibold ${s.text}`}>{r.Name}</div>
                                            {r.Description && <div className={`line-clamp-1 text-xs ${s.muted}`}>{r.Description}</div>}
                                        </td>
                                        <td className={s.td}><Pill tone="primary">{r.EvaluationType === "resume" ? "Resume" : "Interview"}</Pill></td>
                                        <td className={s.td}>{scopeLabel(r)}</td>
                                        <td className={`${s.td} tabular-nums`}>{r.CategoryCount}</td>
                                        <td className={`${s.td} text-right`}>
                                            <div className="flex justify-end gap-1">
                                                <button type="button" className={s.btnSecondary} onClick={() => setEditing(r)} aria-label={`Edit ${r.Name}`}><Pencil size={14} /></button>
                                                <button type="button" className={s.btnDanger} onClick={() => remove(r)} aria-label={`Archive ${r.Name}`}><Trash2 size={14} /></button>
                                            </div>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                )}
            </Panel>
            {editing && (
                <EvaluationEditor evaluationId={editing.EvaluationID} orgs={orgs} programs={options.programs}
                                  onClose={() => setEditing(null)} onSaved={async () => { setEditing(null); await load(); }} />
            )}
        </>
    );
}

const blankCategory = () => ({ name: "", weight: 0, description: "", rubric: "" });

function EvaluationEditor({ evaluationId, orgs, programs, onClose, onSaved }) {
    const s = useOrgStyles();
    const isNew = !evaluationId;
    const [form, setForm] = useState({ evaluationType: "resume", name: "", description: "", additionalInstructions: "" });
    const [scope, setScope] = useState({ orgId: null, programId: null });
    const [categories, setCategories] = useState([blankCategory()]);
    const [loading, setLoading] = useState(!isNew);
    const [saving, setSaving] = useState(false);
    const [error, setError] = useState("");
    const [openRubric, setOpenRubric] = useState(null);

    useEffect(() => {
        if (isNew) return;
        api.get(`/org/admin/evaluations/${evaluationId}`)
            .then((res) => {
                const ev = res.data.evaluation;
                setForm({ evaluationType: ev.EvaluationType, name: ev.Name || "", description: ev.Description || "", additionalInstructions: ev.AdditionalInstructions || "" });
                setScope({ orgId: ev.OrgID, programId: ev.ProgramID });
                setCategories(ev.categories.map((c) => ({ name: c.Name, weight: c.Weight, description: c.Description || "", rubric: c.Rubric || "" })));
            })
            .catch((err) => setError(apiError(err)))
            .finally(() => setLoading(false));
    }, [evaluationId, isNew]);

    const total = categories.reduce((sum, c) => sum + (Number(c.weight) || 0), 0);
    const setCat = (i, key, value) => setCategories((cs) => cs.map((c, j) => (j === i ? { ...c, [key]: value } : c)));

    const loadDefaults = async () => {
        try {
            const path = form.evaluationType === "resume" ? "/admin/resume-scoring/categories" : "/admin/interview-scoring/categories";
            const res = await api.get(path);
            const active = (res.data.categories || []).filter((c) => c.isActive !== false && c.isActive !== 0);
            setCategories(active.map((c) => ({ name: c.Name, weight: c.Weight, description: c.Description || "", rubric: c.Rubric || "" })));
        } catch (err) {
            setError(apiError(err, "Couldn't load the default categories."));
        }
    };

    const submit = async (e) => {
        e.preventDefault();
        setSaving(true);
        setError("");
        const payload = { ...form, categories: categories.map((c) => ({ ...c, weight: Number(c.weight) || 0 })) };
        try {
            if (isNew) await api.post("/org/admin/evaluations", { ...payload, ...scope });
            else await api.put(`/org/admin/evaluations/${evaluationId}`, payload);
            await onSaved();
        } catch (err) {
            setError(apiError(err));
            setSaving(false);
        }
    };

    return (
        <OrgModal
            isOpen
            wide
            onClose={onClose}
            title={isNew ? "New custom evaluation" : "Edit evaluation"}
            footer={<>
                <span className={`mr-auto self-center text-sm font-semibold tabular-nums ${total === 100 ? "text-emerald-600" : (s.dark ? "text-amber-300" : "text-amber-600")}`}>
                    Weights: {total} / 100
                </span>
                <button type="button" className={s.btnSecondary} onClick={onClose}>Cancel</button>
                <button type="submit" form="eval-editor" className={s.btnPrimary} disabled={saving || loading || total !== 100 || (isNew && !(scope.orgId || scope.programId))}>
                    {saving && <Loader2 size={14} className="animate-spin" />} {isNew ? "Create" : "Save"}
                </button>
            </>}
        >
            <Alert onClose={() => setError("")}>{error}</Alert>
            {loading ? <div className="flex justify-center py-10"><Loader2 className={`animate-spin ${s.muted}`} /></div> : (
                <form id="eval-editor" onSubmit={submit} className="space-y-4">
                    <div className="grid gap-4 sm:grid-cols-2">
                        <Field label="Type" htmlFor="ev-type">
                            <select id="ev-type" className={s.input} value={form.evaluationType} disabled={!isNew}
                                    onChange={(e) => setForm((f) => ({ ...f, evaluationType: e.target.value }))}>
                                <option value="resume">Resume review</option>
                                <option value="interview">Interview prep</option>
                            </select>
                        </Field>
                        <Field label="Applies to" htmlFor="ev-scope" hint={isNew ? undefined : "To move an evaluation, archive it and create a new one."}>
                            {isNew
                                ? <ScopePicker orgs={orgs} programs={programs} value={scope} onChange={setScope} idPrefix="ev" />
                                : <input id="ev-scope" className={s.input} disabled
                                         value={scope.programId ? programs.find((p) => p.ProgramID === scope.programId)?.ProgramName || "Program" : orgs.find((o) => o.OrgID === scope.orgId)?.OrgName || "Organization"} />}
                        </Field>
                        <Field label="Name" htmlFor="ev-name" className="sm:col-span-2">
                            <input id="ev-name" className={s.input} required maxLength={200} value={form.name}
                                   onChange={(e) => setForm((f) => ({ ...f, name: e.target.value }))} placeholder="e.g. PVAMU Career Fair Resume Standard" />
                        </Field>
                        {/* old <Field label="Description (shown to students)" htmlFor="ev-desc" className="sm:col-span-2"> */}
                        <Field label="Description (shown to clients)" htmlFor="ev-desc" className="sm:col-span-2">
                            <input id="ev-desc" className={s.input} maxLength={1000} value={form.description}
                                   onChange={(e) => setForm((f) => ({ ...f, description: e.target.value }))} />
                        </Field>
                        <Field label="Additional instructions for the AI (optional)" htmlFor="ev-instr" className="sm:col-span-2"
                               hint="Added to the scoring prompt, e.g. “Prefer one-page resumes; the Education section should come before Experience.”">
                            <textarea id="ev-instr" rows={3} className={s.input} maxLength={2000} value={form.additionalInstructions}
                                      onChange={(e) => setForm((f) => ({ ...f, additionalInstructions: e.target.value }))} />
                        </Field>
                    </div>

                    <div>
                        <div className="mb-2 flex flex-wrap items-center justify-between gap-2">
                            <h4 className={`text-sm font-bold ${s.text}`}>Scoring categories</h4>
                            <div className="flex gap-3">
                                <button type="button" className={s.btnLink} onClick={loadDefaults}>Start from the default categories</button>
                                <button type="button" className={s.btnLink} onClick={() => setCategories((cs) => [...cs, blankCategory()])} disabled={categories.length >= 12}>
                                    + Add category
                                </button>
                            </div>
                        </div>
                        <div className="space-y-3">
                            {categories.map((c, i) => (
                                <div key={i} className={`rounded-xl border p-3 ${s.subPanel}`}>
                                    <div className="flex gap-2">
                                        <input aria-label={`Category ${i + 1} name`} placeholder="Category name" required maxLength={100}
                                               className={s.input} value={c.name} onChange={(e) => setCat(i, "name", e.target.value)} />
                                        <div className="relative w-28 flex-shrink-0">
                                            <input aria-label={`Category ${i + 1} weight`} type="number" min={0} max={100} required
                                                   className={`${s.input} pr-7`} value={c.weight} onChange={(e) => setCat(i, "weight", e.target.value)} />
                                            <span className={`pointer-events-none absolute right-3 top-1/2 -translate-y-1/2 text-sm ${s.muted}`}>%</span>
                                        </div>
                                        <button type="button" className={s.btnDanger} aria-label={`Remove category ${i + 1}`}
                                                onClick={() => setCategories((cs) => cs.filter((_, j) => j !== i))} disabled={categories.length === 1}>
                                            <Trash2 size={14} />
                                        </button>
                                    </div>
                                    <input aria-label={`Category ${i + 1} description`} placeholder="What this category measures" maxLength={500}
                                           className={`${s.input} mt-2`} value={c.description} onChange={(e) => setCat(i, "description", e.target.value)} />
                                    <button type="button" className={`mt-2 ${s.btnLink}`} onClick={() => setOpenRubric(openRubric === i ? null : i)}>
                                        {openRubric === i ? "Hide rubric" : c.rubric ? "Edit rubric" : "Add rubric (score bands)"}
                                    </button>
                                    {openRubric === i && (
                                        <textarea aria-label={`Category ${i + 1} rubric`} rows={4} maxLength={8000} className={`${s.input} mt-2 font-mono text-xs`}
                                                  placeholder={"- 90-100: …\n- 70-89: …\n- 0-69: …"} value={c.rubric} onChange={(e) => setCat(i, "rubric", e.target.value)} />
                                    )}
                                </div>
                            ))}
                        </div>
                    </div>
                </form>
            )}
        </OrgModal>
    );
}
